import {ref, reactive, nextTick} from "vue";
import TwilioClientObserver from "./TwilioClientObserver";
import axios from "axios";
import cloneDeep from "lodash/cloneDeep";
import {useConversation} from "../Stores/Conversation";
import {useWorkspace} from "../Stores/Workspaces";
import {useWorkspaceTree} from "../Stores/WorkspaceTree";
import {useAppState} from "../Stores/AppState";
import trackUserInactive from "./track-user-inactivity";
import {useUserStore} from "../Stores/User";
import {useInvitation} from "../Stores/Invitation";
import {de} from "vuetify/locale";
import {useTimeTrackerStore} from "../Stores/TimeTracker";
import {useRequest} from "../Components/Chat/Store/Request";
import {useTeam} from "../Components/Custom/Team/Store/Team";
import {useAppState as useAppSateScreenShot} from "../Components/ScreenShots/Store/AppState";
import {checkImageExists, grabImageUrls, getIndexFromImageSrc} from "./Media";
import HttpStatusCodes from "../Constants/http.js";
import Utilities from "../Helpers/utilities.js";
import {useTeamPanel} from "Admin/js/Stores/TeamPanel.js";
import {handleInviteApi} from "Admin/js/Helpers/chin";
import isEmpty from "lodash/isEmpty";
import {EVENT_SUB_TYPES, ENTITY_TYPES} from "../Stores/MessageEvents";
import {uploadFile} from "./Uploader";
import {useChat} from "Admin/js/Components/Chat/Store/Chat.js";
import {
    isHourlyDigestSubjectVisibleOnWorkline,
    isHourlyUplineDigestMessageData,
} from "../Helpers/hourlyDigestActivityQueue.js";
import {
    isProfileRecipientOfTaskStartResumeActivityQueue,
    isTaskStartOrResumeSubType,
} from "../Helpers/taskTimerActivityQueue.js";
import {
    canReplaceMessageScroll,
    effectiveLastReadMessageIndex,
    findFirstUnreadMessage,
    findNeverReadInviteSeparatorAfterIndex,
    manualUnreadCountFromLatest,
    MESSAGE_SCROLL_REASONS,
    resolveActivityQueueUnreadStep,
    resolveManualUnreadPersistence,
    coalesceManualUnreadPersist,
    shouldRevertManualUnreadMarker,
    resolvePendingScrollAcknowledgement,
    resolveStaleActivityQueueUnreadReconcile,
    shouldRunVisibleUnreadAcknowledgement,
    shouldSuppressVisibleRead,
    unreadCountAfterLastRead,
    messagesAfterLastRead,
    countMessagesAfterLastRead,
    UNREAD_VISIBLE_READ_SETTLE_MS,
} from "../Helpers/unreadMessages.js";

function isSameBoardAndStateItemMove(message) {
    const sub_type = message?.data?.sub_type;
    const old_board = message?.data?.old_value?.board_id;
    const new_board = message?.data?.new_value?.board_id;
    const old_state = message?.data?.old_value?.automatic_close;
    const new_state = message?.data?.new_value?.automatic_close;

    const isItemMove = sub_type === EVENT_SUB_TYPES.ACTION_ITEM_MOVE;
    const isSameBoard = old_board === new_board;
    const isSameState = old_state === new_state;

    return isItemMove && isSameBoard && isSameState;
}

function isRenamedChatEvents(message) {
    const sub_type = message?.data?.sub_type;

    const renameEventList = [
        EVENT_SUB_TYPES.ACTION_SPACE_GROUP_NAME_RENAMED,
        EVENT_SUB_TYPES.ACTION_SPACE_NAME_RENAMED,
        EVENT_SUB_TYPES.ACTION_BOARD_GROUP_NAME_RENAMED,
        EVENT_SUB_TYPES.ACTION_BOARD_NAME_RENAMED,
        EVENT_SUB_TYPES.ACTION_ITEM_GROUP_NAME_RENAMED,
        EVENT_SUB_TYPES.ACTION_ITEM_TITLE_RENAMED,
        EVENT_SUB_TYPES.ACTION_TOPIC_TITLE_RENAMED,
        EVENT_SUB_TYPES.ACTION_GROUP_TITLE_RENAMED,
    ];

    return renameEventList.includes(sub_type);
}

function isNotesChatEvents(message) {
    return message?.data?.type === "notes";
}

function createConversationForOpenedListItem() {
}

// import conversationApi from '../../../Admin/js/composition-api/conversations'
// const { loadTokenForConversation,
function updateConversationLastMessageSentAt(conversation_id, data) {
    axios.post(`/conversations/${conversation_id}/message-sent-at`, data);
}

function getCurrentConversationId() {
    return useConversation().active?.id;
}

function createTwilioConversationForConversation() {
}

function showConnectingIndicator() {
}

function hideConnectingIndicator() {
}

function fetchConversationById() {
}

// import {useConversation} from '../Stores/Conversation'
// import {de} from "vuetify/locale";

function updateConversationListOrderingWhenConversationReceivedAMessage(
    conversation_id,
) {
    const conversationStore = useConversation();
    conversationStore.moveConversationToTop(conversation_id);
}

function selectConversationAsCurrentById() {
}

function updateCurrentConversationDraft() {
}

function getDraftForConversation() {
}

// } = conversationApi();

function updateUnreadMessagesCountBy() {
} // from '../composition-api/helpers';
// import LoggedInUserApi from '../composition-api/logged-in-user';
function loggedInUserChatIdentity() {
    return window.profile?.twilio_identity;
}

function loggedInUserName() {
    return window.profile.name;
}

function getItemById() {
}

function setConverstionForItem() {
}

function prepareBreadCumbForBoardAndItem() {
}

const {subscribeWithIdentity} = TwilioClientObserver();

const intlDateTimeFormatter = ref(
    new Intl.DateTimeFormat("en", {
        dateStyle: "medium" /* timeStyle: 'short' */,
    }),
);
const intlDateTimeFormatterOnlyTime = ref(
    new Intl.DateTimeFormat("en", {timeStyle: "short"}),
);
const {is_inactive} = trackUserInactive();

const STATUS = {
    TYPING: "typing",
    ACTIVE: "active",
    INACTIVE: "inactive",
    ABSENT: "absent",
    CONNECTED: "connected",
    OFFLINE: "offline",
    FAILED: "failed",
};

const MESSAGE = {
    STATUS: "status",
    TEXT: "text",
    MEDIA: "media",
    META: "meta",
    STATE: "state",
    IMAGE: "image",
    VIDEO: "video",
    PAYMENT: "payment",
    INVITE: "invite",
    UNINVITE: "uninvite",
    ASSIGN: "assign",
    UNASSIGN: "unassign",
    NAVIGATION: "navigation",
    ATTENTION: EVENT_SUB_TYPES.REQUEST_ATTENTION,
    ATTENTION_CLOSED: EVENT_SUB_TYPES.REQUEST_ATTENTION_CLOSED,
    REQUEST_STATUS: EVENT_SUB_TYPES.REQUEST_STATUS,
    REQUEST_STATUS_CLOSED: EVENT_SUB_TYPES.REQUEST_STATUS_CLOSED,
    SUPPORT: EVENT_SUB_TYPES.REQUEST_SUPPORT,
    SUPPORT_CLOSED: EVENT_SUB_TYPES.REQUEST_SUPPORT_CLOSED,
    TIMER: "timer",
    CONVERSATION: "conversation",
    NOTES: "notes",
    ACTION: "action",
};

const TYPE = {
    ITEM_GROUP: ENTITY_TYPES.ITEM_GROUP,
    ITEM: ENTITY_TYPES.ITEM,
    ITEM_FEEDBACK: "feedback",
    BOARD_GROUP: ENTITY_TYPES.BOARD_GROUP,
    BOARD: ENTITY_TYPES.BOARD,
    WORKSPACE_GROUP: ENTITY_TYPES.WORKSPACE_GROUP,
    WORKSPACE: ENTITY_TYPES.WORKSPACE,
    GROUP: "group",
    SPACE_GROUP: ENTITY_TYPES.WORKSPACE_GROUP,
    SPACE: ENTITY_TYPES.WORKSPACE,
    GROUP_ONE_OFF: "group-one-off",
    DM: "dm",
};

class Conversation {
    conversationsClient = null;

    MESSAGES_CHUNK_SIZE = 50;

    state = reactive({
        messages: [],
        bufferedMessages: [],
        reserved_messages: [],
        status: "No Conversation",
        hideLoadingIndicator: false,
        typingUser: "",
        messageTyped: "",
        isConversationPreparationInProgress: 0,
        name: "",
        id: null,
        sid: null,
        type: null,
        type_id: null,
        participants: [],
        last_message_send_at: null,
        space_id: null,
        space_name: null,
        board_id: null,
        board_name: null,
        assignedUser: null,
        is_initial_messages_fetched: false,
        is_archived: false,
        is_paginated: false,
        is_clear_messages: false,
        twilioConversation: null,
        typingUsers: [],
        is_invitation_in_progress: false,
        isLoadingMoreMessages: false,
        isCreatingConversation: false,
        lastMessageIndexFromNewlyLoadedMessages: null,
        total_messages: 0,
        urgent_request: [],
        unread_message_count: 0,
        originalData: [],
        message_fetching_attempt: 0,
        avatar_url: null,
        draft_message: "",
        is_flagged: false,
        isLoadingArchivedConversation: false,
        stop_loader_on_load: false,
        handle_send_to_conversation_interval: null,
        buffered_edited_message: [],
        unsend_messages: [],
        buffered_image_upload_message: [],
        pending_message_to_jump: null,
        pending_scroll_to_sid: null,
        pending_scroll_reason: null,
    });

    twilioConversation = reactive({
        value: null,
    });

    cachedMessages = [];

    // originalData = null;

    //userTypedLastAt = null;

    //typingTimeOutHandler = null;

    //typingThrottler = null;

    //usersTypingSet = new Set();

    myCurrentStatus = "";

    activeUsers = []; //Seems not required anymore

    inActiveUsers = []; //Seems not required anymore

    absentUsers = []; //Seems not required anymore

    //offlineUsers = [];

    //isMuted = false;

    //unreadMessagesCount = 0;

    messagesNotProcessed = [];

    isLastReadUsersOnMessagesSet = false;

    pending_visible_read_index = null;

    visible_read_timeout = null;

    /** Ignore IntersectionObserver reads until this time (unread jump settle). */
    suppress_visible_read_until = 0;

    visible_read_suppress_timeout = null;

    /** After Mark as unread, hold viewport reads until scroll or leave. */
    hold_visible_read_after_manual_unread = false;

    manual_unread_scroll_release = null;

    /** Visit / AQ settle: auto-ack visible manual unread after load/scroll. */
    visible_unread_ack_timeout = null;

    /** Per-viewer Mongo marker: first unread message index (does not rewind Twilio). */
    manual_unread_message_index = null;

    /** Latest unread cursor waiting to be written. One request at a time. */
    manual_unread_persist_job = null;

    /** In-flight drain of manual_unread_persist_job. */
    manual_unread_persist_pump = null;

    /**
     * Never-read (Twilio last-read null/0): wait for loaded messages before
     * placing the New Messages line on the current user's invite.
     */
    pending_never_read_separator_refine = false;

    //totalParticipants = 0;

    //twilioParticipants = null;

    didISetCurrentConversationStateToLoading = false;

    auth_user_chat_identity = null;

    authUser = null;

    //  avatar_url = null;

    //chat_access_token = null;

    scrollBarHandler = () => {
    };

    toggleUserOfInactivity = () => {
    };

    updateUserStatusIndicators = () => {
    };

    isRegisterdForMessageAddedEvent = false;

    lastCurrentUrlNotificationSentAt = null;

    isFakeConversation = false;

    recent_active_panel = null; //Seems not required anymore

    isRequestToCreateTwilioConversationAlreadyMade = false;

    isSendingBufferedMessagesInProgress = false;

    // isToSendGroupMessage = false;

    // isToSendBoardMessage = false;

    space = null;

    board = null;

    loadingMoreMessagesTimeOut = null;

    index_key = 0;

    key = null;

    temporary_id = null;

    auto_focus = false;

    updateDraftMessage(message = "") {
        this.state.draft_message = message;
    }

    constructor(conv, isInitialize = true) {
        this.setConversationVariables(conv);
        if (conv.is_quick_load || isInitialize) {
            this.initialize();
        }
        this.key = this.state.id || Date.now();
    }

    async initialize(dontUpdateStatus = false) {
        if (!this.getConversationSid()) return;
        this.setUpAndPrepareRequiredFields();
        !dontUpdateStatus && this.setStatusToPreparing();

        this.prepare(); // prepares Twilio Client
        //this.setAssignedUser()
    }

    async setAssignedUser(user_id = null) {
        if (!user_id) {
            useInvitation()
                .getInvitedMembers(this)
                .then((res) => {
                    this.state.assignedUser =
                        res?.data?.assigned_profile_id ?? null;
                });
        } else this.state.assignedUser = user_id;
    }

    // setAssignedUser(user_id = null) {
    //     if (!user_id) {
    //         useInvitation().getInvitedMembers(this)
    //             .then (res => {
    //                 user_id = res?.data?.assigned_profile_id ?? null
    //                 this.state.assignedUser = user_id
    //             })
    //     }
    //     this.state.assignedUser = user_id
    // }

    setUpAndPrepareRequiredFields() {
        this.removeAsFakeConversation();
        this.prepareUserChatIdentity();
    }

    prepareUserChatIdentity() {
        //const participants = this.getParitcipants();
        const user_profile = window.profile; //participants?.find((paricipant) => paricipant.twilio_identity == loggedInUserChatIdentity());
        this.auth_user_chat_identity = user_profile?.twilio_identity;
        this.authUser = user_profile;
    }

    resetAfterContactsInvited(conversation) {
        this.setConversationVariables(conversation);
        this.forceUiUpdate();
        return;
        /*
            User can be invited directly - need to create a conversation and add 2 users
            User cna be invited on Conversation - just add participant
            */
        /* if no conversation created before, then do it now */
        if (this.hasTwilioConversationSet()) return;
        // create conversation now
        //console.log('Creating conversation....');
        this.initialize();
    }

    sendUnInvitationMessage(new_profiles) {
        let names = "";

        const current_conversation = useConversation().active;
        let authUser = current_conversation?.authUser;

        new_profiles.forEach((v) => {
            names += "&#x2022; " + v.name + "<br />";
        });
        const message = authUser.first_name + " has removed: <br />" + names;

        this.sendMessage(message);
    }

    getNewInviteProfile(old_participants, data) {
        if (!useUserStore().newInvitedMember) return [];
        else {
            useUserStore().setNewInvitedMember(false);

            const current_conversation = useConversation().active;
            const current_conversation_participants =
                current_conversation.participants;

            current_conversation?.prepareUserChatIdentity();
            let authUser = current_conversation?.authUser;
            let profiles = [];

            current_conversation_participants.forEach((v) => {
                if (authUser.twilio_identity != v.twilio_identity) {
                    if (old_participants.length == 0) {
                        profiles.push(v);
                        return;
                    }

                    if (
                        old_participants.find(
                            (ov) => v.twilio_identity != ov.twilio_identity,
                        )
                    ) {
                        profiles.push(v);
                    }
                }
            });

            return profiles;
        }
    }

    setConversationVariables(conv) {
        if (!conv)
            return console.trace("conversation details are not valid", conv);

        this.originalData = conv;
        this.state.name = conv.type == "dm" ? "" : conv.name;
        this.state.id = conv.id;
        this.state.sid = conv.sid;
        this.state.type = conv.type;
        this.state.type_id = conv.type_id;
        this.state.space_id = conv.space_id;
        this.state.space_name = conv.space_name;
        this.state.board_id = conv.board_id;
        this.state.board_name = conv.board_name;
        this.state.participants = conv.participants ?? [];
        //this.totalParticipants = this.state.participants.length;
        this.state.last_message_send_at = conv.last_message_send_at;
        this.state.user_profile_id_assignee =
            conv?.item?.version?.user_profile_id_assignee;
        // this.auth_user_chat_identity = window.profile?.id;
        this.auth_user_chat_identity = window.profile?.twilio_identity;
        this.state.is_archived = false;
        this.state.is_paginated = conv?.is_paginated === true;
        // this.attachItemsSpaceAndBoard()

        this.state.avatar_url = conv.avatar_url;
        this.is_quick_load = conv.is_quick_load;
        this.state.is_one_off = Boolean(conv?.is_one_off);
        this.state.is_flagged = Boolean(conv.is_flagged);

        if (Object.prototype.hasOwnProperty.call(conv,             "manual_unread_message_index")) {
            this.manual_unread_message_index = conv.manual_unread_message_index ?? null;
        }

        if (conv && conv.id) {
            this.removeAsFakeConversation();
        }

        this.prepareName();
        if (this.itemId) setConverstionForItem(this.itemId, this.id);
    }

    attachItemsSpaceAndBoard() {
        if (this.isItem()) {
            const tree = useWorkspaceTree();
            const item = tree.getItemById(this.type_id);
            if (!item) {
                return;
            }
            this.item = item;
            this.board = tree.getBoardById(item.boardId ?? item.board_id);
            this.space = tree.getWorkspaceById(
                item.workspaceId ?? item.workspace_id,
            );
        }
    }

    setCachedMessages(messages) {
        this.cachedMessages = messages?.length ? messages : [];
        if (!this.cachedMessages.length) return;

        this.dontShowLoadingIndicators();
        this.moveScrollBar();
    }

    clearCachedMessages() {
        this.cachedMessages = [];
    }

    setAsFakeConversation() {
        this.isFakeConversation = true;
    }

    setStopLoaderOnLoad() {
        this.state.stop_loader_on_load = true;
    }

    removeStopLoaderOnLoad() {
        this.state.stop_loader_on_load = false;
    }

    setAsArchivedConversation() {
        this.state.is_archived = true;
        // clear counter on archive conversation.
        useConversation().addUnreadConversation(0, {
            id: this.id,
            itemId: this.itemId,
            name: this.name,
            lastMessageDateCreated:
            this.getTwilioConversation()?.lastMessage?.dateCreated,
        });
        this.unreadMessagesCount = 0;
    }

    setArchiveStatus(is_archive = true) {
        this.state.is_archived = is_archive;
    }

    setIsRequireClearMessages() {
        this.state.is_clear_messages = true;
    }

    removeAsFakeConversation() {
        this.isFakeConversation = false;
    }

    removeAsArchivedConversation() {
        this.state.is_archived = false;
    }

    isFake() {
        return this.isFakeConversation;
    }

    isArchived() {
        return this.state.is_archived;
    }

    isPaginated() {
        return this.state.is_paginated === true;
    }

    removeIsPaginated() {
        return this.state.is_paginated = false;
    }

    hasInitialMessages() {
        return this.state.is_clear_messages;
    }

    get id() {
        return this.state.id;
    }

    get sid() {
        return this.state.sid;
    }

    get name() {
        return this.state.name;
    }

    get type() {
        return this.state.type;
    }

    get type_id() {
        return this.state.type_id;
    }

    get itemId() {
        return this.state.type_id;
    }

    get resourceId() {
        return this.state.type_id;
    }

    get space_id() {
        if (this.state.space_id) {
            return this.state.space_id;
        }

        if (this.is_item) {
            const tree = useWorkspaceTree();
            const item = tree.getItemById(this.itemId);
            if (!item) {
                return null;
            }
            const space = tree.getWorkspaceById(
                item.workspaceId ?? item.workspace_id,
            );
            return space?.id;
        }

        return null;
    }

    get space_name() {
        return this.state.space_name;
    }

    get board_id() {
        if (this.state.board_id) {
            return this.state.board_id;
        }

        if (this.is_item) {
            const tree = useWorkspaceTree();
            const item = tree.getItemById(this.itemId);
            if (!item) {
                return null;
            }
            const board = tree.getBoardById(item.boardId ?? item.board_id);
            return board?.id;
        }

        return null;
    }

    get avatar_url() {
        return this.state.avatar_url;
    }

    get board_name() {
        return this.state.board_name;
    }

    get is_space_group() {
        return this.state.type == TYPE.WORKSPACE_GROUP;
    }

    get is_space() {
        return this.state.type == TYPE.WORKSPACE;
    }

    get is_board_group() {
        return this.state.type == TYPE.BOARD_GROUP;
    }

    get is_board() {
        return this.state.type == TYPE.BOARD;
    }

    get is_item_group() {
        return this.state.type === TYPE.ITEM_GROUP;
    }

    get is_item() {
        return (
            this.state.type === TYPE.ITEM ||
            this.state.type === TYPE.ITEM_FEEDBACK
        );
    }

    get is_group() {
        return this.state.type == TYPE.GROUP;
    }

    get is_group_one_off() {
        return this.state.type == TYPE.GROUP_ONE_OFF;
    }

    get is_topic() {
        return this.state.is_one_off == true;
    }

    get is_dm() {
        return this.state.type == TYPE.DM;
    }

    get lastMessageSentAt() {
        return this.state.last_message_sent_at;
    }

    get is_offline() {
        return (
            this.state.status == STATUS.OFFLINE ||
            this.state.status == STATUS.FAILED
        );
    }

    get unreadMessagesCount() {
        return this.state.unread_message_count;
    }

    get participants() {
        return this.state.participants;
    }

    get originalData() {
        return this.state.originalData;
    }

    get is_archived() {
        return this.state.is_archived || this.state.originalData.is_archived;
    }

    get stop_loader_on_load() {
        return this.state.stop_loader_on_load;
    }

    /* get twilioConversation(){
        return this.state.twilioConversation
    } */

    set name(name) {
        this.state.name = name;
        this.forceUiUpdate();
    }

    set board_name(board_name) {
        return (this.state.board_name = board_name);
    }

    set space_name(space_name) {
        return (this.state.space_name = space_name);
    }

    set space_id(space_id) {
        return (this.state.space_id = space_id);
    }

    set avatar_url(avatar_url) {
        return (this.state.avatar_url = avatar_url);
    }

    set unreadMessagesCount(count) {
        return (this.state.unread_message_count = count);
    }

    set participants(participants) {
        this.state.participants = participants;
    }

    set originalData(original_data) {
        this.state.originalData = original_data;
    }

    updateKey() {
        this.key = Date.now() + (this.state.id ?? 10);
    }

    updateSpaceAndBoard(space, board) {
        if (board?.id) {
            this.state.board_id = board.id;
        }

        if (board?.name) {
            this.state.board_name = board.name;
        }

        if (space?.id) {
            this.state.space_id = space.id;
        }

        if (space?.name) {
            this.state.space_name = space.name;
        }

        if (space) {
            this.state.avatar_url = space?.avatar_url;
        }
    }

    updateName(name) {
        this.name = name;
    }

    updateNameAndId(name, id) {
        this.setMessageTyped("");
        this.state.id = id;
        this.name = name;
    }

    originalDetails() {
        const messages = [];
        // latest 100 messages only
        this.getMessages()
            ?.slice(-100)
            .forEach((message) => {
                messages.push({...message});
            });
        return {
            ...this.originalData,
            name: this.getName(),
            messages,
        };
    }

    async jumpToMessage(
        messageId,
        messageIndex,
        reason = MESSAGE_SCROLL_REASONS.SEARCH,
    ) {
        if (!this.hasTwilioConversationSet()) {
            return;
        }

        const existing = this.state.messages.find(
            (m) => m.sid === messageId || m.index === messageIndex,
        );
        if (existing) {
            this.requestScrollToMessage(existing.sid, reason);
            return;
        }

        if (!canReplaceMessageScroll(this.state.pending_scroll_reason, reason)) {
            return;
        }

        this.setStatusToLoadingMessages();
        this.state.messages = [];
        this.clearPendingScroll();

        // Ensure anchor is within bounds (Twilio index starts at 0)
        // Adjusting anchor to have context before and after the message
        const anchor = Math.max(
            0,
            messageIndex + Math.floor(this.MESSAGES_CHUNK_SIZE / 2),
        );

        try {
            const messagePaginator =
                await this.getTwilioConversation().getMessages(
                    this.MESSAGES_CHUNK_SIZE,
                    anchor,
                );
            messagePaginator.items.forEach((message) => {
                this.addNewMessage(
                    message,
                    this.parseTwilioMessageBody(message),
                    false,
                );
            });

            const target_sid = this.resolveTwilioSidForJumpTarget(
                messageId,
                messageIndex,
            );
            if (target_sid) {
                this.requestScrollToMessage(target_sid, reason);
            }

            this.forceUiUpdate();

            // Note: message component will pick up pending_scroll_to_sid on mount
        } catch (error) {
            console.error("Jump to message failed", error);
        }
    }

    /**
     * Search hits pass Mongo/Typesense id as messageId; UI and Twilio use message.sid (e.g. IM...).
     * After loading a chunk, resolve the scroll target to Twilio sid via index (authoritative) or sid match.
     *
     * @param {string|number} messageId
     * @param {string|number} messageIndex
     * @returns {string|null}
     */
    resolveTwilioSidForJumpTarget(messageId, messageIndex) {
        const messages = this.state.messages;
        if (
            messageIndex !== undefined &&
            messageIndex !== null &&
            messageIndex !== ""
        ) {
            const by_index = messages.find(
                (m) => Number(m.index) === Number(messageIndex),
            );
            if (by_index?.sid) {
                return by_index.sid;
            }
        }
        if (messageId !== undefined && messageId !== null && messageId !== "") {
            const by_sid = messages.find((m) => m.sid === messageId);
            if (by_sid?.sid) {
                return by_sid.sid;
            }
        }

        return null;
    }

    scrollToMessage(messageId) {
        window.dispatchEvent(
            new CustomEvent("scroll-to-message", {
                detail: {messageId: "message-" + messageId},
            }),
        );
    }

    /**
     * Single entry point for the three chat scroll intents. A lower priority
     * reason (the unread line) never replaces a pending search or
     * "view original message" jump.
     *
     * @param {string} message_sid
     * @param {string} reason one of MESSAGE_SCROLL_REASONS
     * @returns {boolean} whether the scroll was requested
     */
    requestScrollToMessage(
        message_sid,
        reason = MESSAGE_SCROLL_REASONS.SEARCH,
    ) {
        if (!message_sid) {
            return false;
        }

        if (!canReplaceMessageScroll(this.state.pending_scroll_reason, reason)) {
            this.logUnread("scroll-request-rejected", {
                reason,
                pending_reason: this.state.pending_scroll_reason,
                pending_sid: this.state.pending_scroll_to_sid,
            });
            return false;
        }

        this.logUnread("scroll-request", {
            reason,
            message_sid,
            replaced_reason: this.state.pending_scroll_reason,
        });

        this.state.pending_scroll_to_sid = message_sid;
        this.state.pending_scroll_reason = reason;

        // pending_scroll_to_sid already blocks viewport reads for the jump.
        // Drop any flush queued before the unread target was chosen.
        if (reason === MESSAGE_SCROLL_REASONS.UNREAD) {
            this.clearPendingVisibleRead();
        }

        nextTick(() => {
            this.scrollToMessage(message_sid);
        });

        return true;
    }

    clearPendingScroll(message_sid = null) {
        if (message_sid && this.state.pending_scroll_to_sid !== message_sid) {
            return;
        }

        const cleared_reason = this.state.pending_scroll_reason;

        if (this.state.pending_scroll_to_sid) {
            this.logUnread("scroll-done", {
                reason: cleared_reason,
                message_sid: this.state.pending_scroll_to_sid,
            });
        }

        this.state.pending_scroll_to_sid = null;
        this.state.pending_scroll_reason = null;

        // clearPendingScroll runs when the jump begins; keep suppressing until
        // the smooth scroll can settle near the unread line.
        if (cleared_reason === MESSAGE_SCROLL_REASONS.UNREAD) {
            this.beginVisibleReadSuppression(UNREAD_VISIBLE_READ_SETTLE_MS, {
                replace: true,
            });
        }
    }

    beginVisibleReadSuppression(duration_ms, {replace = false} = {}) {
        const next_until = Date.now() + duration_ms;
        this.suppress_visible_read_until = replace
            ? next_until
            : Math.max(this.suppress_visible_read_until, next_until);
        this.clearPendingVisibleRead();
        this.scheduleVisibleReadSuppressionRelease();
    }

    scheduleVisibleReadSuppressionRelease() {
        clearTimeout(this.visible_read_suppress_timeout);
        const delay_ms = Math.max(
            0,
            this.suppress_visible_read_until - Date.now(),
        );

        this.visible_read_suppress_timeout = setTimeout(() => {
            this.visible_read_suppress_timeout = null;
            // Manual unread must stay unread until the user scrolls or leaves.
            if (this.hold_visible_read_after_manual_unread) {
                this.logUnread("visible-read-suppress-ended-held", {});
                return;
            }
            // Observers often fired only during the suppress window; intersection
            // does not change again, so force a recheck of what is still on screen.
            this.logUnread("visible-read-suppress-ended", {});
            this.requestVisibleReadRecheck();
        }, delay_ms);
    }

    requestVisibleReadRecheck() {
        window.dispatchEvent(
            new CustomEvent("recheck-visible-message-read", {
                detail: {conversation_id: this.id},
            }),
        );
    }

    clearPendingVisibleRead() {

        clearTimeout(this.visible_read_timeout);
        this.visible_read_timeout = null;
        this.pending_visible_read_index = null;
    }

    isVisibleReadSuppressed() {
        if (this.hold_visible_read_after_manual_unread) {
            return true;
        }

        return shouldSuppressVisibleRead({
            pending_scroll_to_sid: this.state.pending_scroll_to_sid,
            suppress_until: this.suppress_visible_read_until,
        });
    }

    visibleReadSuppressCause() {
        if (this.hold_visible_read_after_manual_unread) {
            return "manual-unread-hold";
        }

        if (this.state.pending_scroll_to_sid) {
            return "unread-scroll-pending";
        }

        if (Date.now() < this.suppress_visible_read_until) {
            return "unread-scroll-settle";
        }

        return null;
    }

    /**
     * Drop a leftover Mark-as-unread hold without rechecking. Fresh visits must
     * allow viewport reads after the unread jump settles.
     */
    clearManualUnreadHold() {
        if (!this.hold_visible_read_after_manual_unread) {
            this.detachManualUnreadScrollRelease();
            return;
        }

        this.hold_visible_read_after_manual_unread = false;
        this.detachManualUnreadScrollRelease();
        this.logUnread("manual-unread-hold-cleared", {});
    }

    armManualUnreadHold() {
        this.hold_visible_read_after_manual_unread = true;
        this.detachManualUnreadScrollRelease();

        // Capture on document so a remounted message list does not lose the
        // listener; only release for scrolls on the messages container.
        const on_scroll = (event) => {
            const target = event.target;
            if (
                !(target instanceof Element) ||
                !target.classList?.contains(
                    "prospus-messages-container__wrapper",
                )
            ) {
                return;
            }

            // Ignore the programmatic jump to the unread line and its settle
            // window; only a real user scroll should clear the hold.
            if (
                this.state.pending_scroll_to_sid ||
                Date.now() < this.suppress_visible_read_until
            ) {
                return;
            }

            this.releaseManualUnreadHold();
        };

        this.manual_unread_scroll_release = on_scroll;
        document.addEventListener("scroll", on_scroll, {
            passive: true,
            capture: true,
        });

    }

    detachManualUnreadScrollRelease() {
        if (!this.manual_unread_scroll_release) {
            return;
        }

        document.removeEventListener(
            "scroll",
            this.manual_unread_scroll_release,
            true,
        );
        this.manual_unread_scroll_release = null;
    }

    releaseManualUnreadHold() {
        if (!this.hold_visible_read_after_manual_unread) {
            this.detachManualUnreadScrollRelease();
            return;
        }

        this.hold_visible_read_after_manual_unread = false;
        this.detachManualUnreadScrollRelease();
        this.logUnread("manual-unread-hold-released", {});
        this.requestVisibleReadRecheck();
    }

    /**
     * Whether the first unread / separator target is on screen in the list.
     *
     * @param {{sid?: string}|null} message
     * @returns {boolean}
     */
    isUnreadMessageVisibleInViewport(message) {
        if (!message?.sid || typeof document === "undefined") {
            return false;
        }

        const el = document.getElementById("message-" + message.sid);
        if (!el) {
            return false;
        }

        const root = el.closest(".prospus-messages-container__wrapper");
        if (!root) {
            return false;
        }

        const root_rect = root.getBoundingClientRect();
        const el_rect = el.getBoundingClientRect();

        // Any overlap is enough: this only gates hold-release / IO recheck so
        // later fully visible unread rows can be marked. The 40% read threshold
        // stays on Message.vue's IntersectionObserver.
        return el_rect.bottom > root_rect.top && el_rect.top < root_rect.bottom;
    }

    /**
     * After a visit / AQ open settles, if unread rows are already visible
     * (e.g. 2nd/3rd last), release the manual hold and let IO mark them read
     * so AQ drops without requiring a user scroll.
     *
     * @param {string} reason
     * @param {number} attempt
     */
    scheduleVisibleUnreadAcknowledgement(reason = "visit-settle", attempt = 0) {
        clearTimeout(this.visible_unread_ack_timeout);
        const delay_ms = UNREAD_VISIBLE_READ_SETTLE_MS + 50;

        this.logUnread("visible-unread-ack-scheduled", {
            reason,
            attempt,
            delay_ms,
            held: this.hold_visible_read_after_manual_unread,
            manual_unread_message_index: this.manual_unread_message_index,
        });

        this.visible_unread_ack_timeout = setTimeout(() => {
            this.visible_unread_ack_timeout = null;
            this.acknowledgeVisibleManualUnreadIfPresent(reason, attempt);
        }, delay_ms);
    }

    /**
     * @param {string} reason
     * @param {number} attempt
     */
    acknowledgeVisibleManualUnreadIfPresent(reason = "visit-settle", attempt = 0) {
        if (!this.shouldRunVisibleUnreadAcknowledgement()) {
            this.logUnread("visible-unread-ack-skipped", {
                reason,
                cause: "conversation not open on message tab",
            });
            return;
        }

        const first_unread = this.firstUnreadMessageForSeparator();
        const near_bottom = this.isScrolledNearBottom();
        const unread_visible = this.isUnreadMessageVisibleInViewport(first_unread);
        const has_manual = this.manual_unread_message_index != null;
        const separator_after_index = this.unreadSeparatorIndex();
        const latest_index = this.getLatestMessageTwilioIndex();
        const last_read = this.currentUserLastReadMessageIndex();

        this.logUnread("visible-unread-ack-check", {
            reason,
            held: this.hold_visible_read_after_manual_unread,
            has_manual,
            near_bottom,
            unread_visible,
            first_unread_index: first_unread?.index ?? null,
            manual_unread_message_index: this.manual_unread_message_index,
            separator_after_index,
            pending_scroll_to_sid: this.state.pending_scroll_to_sid,
            latest_index,
            last_read,
        });

        if (!has_manual && separator_after_index == null) {
            if (
                this.reconcileStaleUnreadForActivityQueue(
                    reason + "-no-separator",
                )
            ) {
                return;
            }

            this.logUnread("visible-unread-ack-skipped", {
                reason,
                cause: "no manual unread or separator",
            });
            return;
        }

        if (!near_bottom && !unread_visible) {
            this.logUnread("visible-unread-ack-skipped", {
                reason,
                cause: "unread not in viewport",
            });
            return;
        }

        if (this.state.pending_scroll_to_sid) {
            const pending_action = resolvePendingScrollAcknowledgement({
                pending_scroll_to_sid: this.state.pending_scroll_to_sid,
                pending_scroll_reason: this.state.pending_scroll_reason,
                unread_visible,
                attempt,
            });

            if (pending_action === "wait") {
                this.logUnread("visible-unread-ack-deferred", {
                    reason,
                    attempt,
                    cause: "scroll still pending",
                    pending_scroll_to_sid: this.state.pending_scroll_to_sid,
                });
                this.scheduleVisibleUnreadAcknowledgement(reason, attempt + 1);
                return;
            }

            if (pending_action === "stop") {
                this.logUnread("visible-unread-ack-skipped", {
                    reason,
                    attempt,
                    cause: "higher priority scroll pending",
                    pending_scroll_to_sid: this.state.pending_scroll_to_sid,
                    pending_scroll_reason: this.state.pending_scroll_reason,
                });
                return;
            }

            this.logUnread("visible-unread-ack-pending-cleared", {
                reason,
                attempt,
                cause: unread_visible
                    ? "unread already visible"
                    : "pending scroll retries exhausted",
                pending_scroll_to_sid: this.state.pending_scroll_to_sid,
            });
            this.clearPendingScroll(this.state.pending_scroll_to_sid);
        }

        if (this.hold_visible_read_after_manual_unread) {
            this.logUnread("visible-unread-ack-release-hold", {reason});
            this.releaseManualUnreadHold();
            return;
        }

        // Nothing left to mark via IO (caught up, or only own past separator).
        if (
            first_unread == null ||
            (latest_index != null &&
                last_read != null &&
                latest_index <= last_read)
        ) {
            if (
                this.reconcileStaleUnreadForActivityQueue(
                    reason + "-nothing-to-mark",
                )
            ) {
                return;
            }
        }

        this.logUnread("visible-unread-ack-recheck", {reason});
        this.requestVisibleReadRecheck();
    }

    /**
     * Unread message indexes currently in the list viewport, after last-read.
     *
     * @param {number|null} last_read_message_index
     * @param {boolean} ignore_own_messages
     * @returns {number[]}
     */
    visibleUnreadMessageIndexes(
        last_read_message_index,
        ignore_own_messages,
    ) {
        if (!Array.isArray(this.state.messages)) {
            return [];
        }

        const indexes = [];
        for (const message of this.state.messages) {
            if (message?.index == null) {
                continue;
            }

            if (
                last_read_message_index != null &&
                message.index <= last_read_message_index
            ) {
                continue;
            }

            if (ignore_own_messages && message.is_author) {
                continue;
            }

            if (this.isUnreadMessageVisibleInViewport(message)) {
                indexes.push(message.index);
            }
        }

        return indexes;
    }

    /**
     * AQ click while this conversation is already open: consume the current
     * unread (Pinia; Twilio only when advancing) and jump to the next.
     */
    advanceUnreadFromActivityQueueClick() {
        const is_manual = this.manual_unread_message_index != null;
        const ignore_own_messages = !is_manual;
        const last_read_message_index = this.currentUserLastReadMessageIndex();
        const visible_indexes = this.visibleUnreadMessageIndexes(
            last_read_message_index,
            ignore_own_messages,
        );
        const step = resolveActivityQueueUnreadStep({
            messages: this.state.messages,
            last_read_message_index,
            visible_indexes,
            is_manual,
            ignore_own_messages,
        });

        this.logUnread("aq-click-step", {
            action: step.action,
            consume_index: step.consume_index,
            last_read_message_index,
            is_manual,
            held: this.hold_visible_read_after_manual_unread,
            visible_indexes,
            unread_count: this.unreadMessagesCount,
            manual_unread_message_index: this.manual_unread_message_index,
            separator_after_index: this.unreadSeparatorIndex(),
            scroll_to_index: step.scroll_to?.index ?? null,
            scroll_to_sid: step.scroll_to?.sid ?? null,
        });

        clearTimeout(this.visible_unread_ack_timeout);
        this.visible_unread_ack_timeout = null;

        if (step.action === "none") {
            this.acknowledgeVisibleManualUnreadIfPresent(
                "aq-click-already-active",
            );
            return;
        }

        if (step.consume_index != null) {
            // Last step drops the hold so catching latest can DELETE Mongo.
            // Earlier steps keep the hold so the viewport does not read the
            // rest, and still persist this one index (ignore_hold on aq-click-step).
            if (is_manual && step.action === "consume") {
                this.clearManualUnreadHold();
            }

            this.updateAuthorsLastReadMessageIndexWith(
                step.consume_index,
                false,
                "aq-click-step",
            );
        }

        if (step.scroll_to?.sid) {
            this.requestScrollToMessage(
                step.scroll_to.sid,
                MESSAGE_SCROLL_REASONS.UNREAD,
            );
        }
    }

    /**
     * Mark a message as the first unread for this viewer only. Persists a Mongo
     * marker and updates the local separator / AQ — does not rewind Twilio.
     *
     * @param {number} message_index Twilio message index to mark unread
     * @returns {Promise<boolean>}
     */
    async markMessageAsUnread(message_index) {
        if (message_index == null || !this.hasTwilioConversationSet()) {
            return false;
        }

        const last_read_message_index = this.currentUserLastReadMessageIndex();

        if (
            last_read_message_index != null &&
            message_index > last_read_message_index
        ) {
            this.logUnread("mark-unread-skipped", {
                message_index,
                last_read_message_index,
                cause: "message already unread",
            });
            return false;
        }

        // -1 = nothing read; the separator sits above message 0.
        const new_last_read = message_index <= 0 ? -1 : message_index - 1;

        this.logUnread("mark-unread", {
            message_index,
            new_last_read,
            previous_last_read: last_read_message_index,
        });

        this.armManualUnreadHold();
        this.clearPendingVisibleRead();

        const participant = this.findParticipantByIdentity(
            this.auth_user_chat_identity,
        );
        if (participant) {
            participant.last_read_message_index =
                new_last_read < 0 ? null : new_last_read;
        }

        try {
            await axios.put(`/conversations/${this.id}/manual-unread`, {
                message_index,
            });

            this.manual_unread_message_index = message_index;

            const unread_count = this.computeManualUnreadCount(message_index);
            this.unreadMessagesCount = unread_count;
            this.updateUnreadMessagesCount();

            this.syncUnreadIndicator({
                last_read_message_index: new_last_read < 0 ? null : new_last_read,
                unread_count,
                force_unread: true,
            });

            useConversation().addUnreadConversation(unread_count, {
                id: this.id,
                itemId: this.itemId,
                name: this.name,
                lastMessageDateCreated:
                    this.getTwilioConversation()?.lastMessage?.dateCreated,
            });

            this.logUnread("mark-unread-done", {
                message_index,
                new_last_read,
                unread_count,
            });

            return true;
        } catch (error) {
            this.releaseManualUnreadHold();
            this.logUnread("mark-unread-failed", {
                message_index,
                error: error?.message,
            });
            return false;
        }
    }

    /**
     * Unread count from a manual first-unread index through the latest message.
     *
     * @param {number} message_index
     * @returns {number}
     */
    computeManualUnreadCount(message_index) {

        const latest_index =
            this.getLatestMessageTwilioIndex() ??
            this.getTwilioConversation()?.lastMessage?.index ??
            null;

        const from_latest = manualUnreadCountFromLatest(
            latest_index,
            message_index,
        );
        if (from_latest > 0) {
            return from_latest;
        }

        if (!Array.isArray(this.state.messages)) {
            return 0;
        }

        return this.state.messages.filter(
            (message) =>
                message?.index != null && message.index >= message_index,
        ).length;
    }

    /**
     * Clear the Mongo manual-unread marker for this viewer.
     *
     * @returns {Promise<void>}
     */
    async clearManualUnreadMarker() {
        if (this.manual_unread_message_index == null || !this.id) {
            return;
        }

        const previous_index = this.manual_unread_message_index;
        this.manual_unread_message_index = null;

        try {
            await axios.delete(`/conversations/${this.id}/manual-unread`);
            this.logUnread("manual-unread-cleared", {
                previous_index,
            });
        } catch (error) {
            if (shouldRevertManualUnreadMarker(this.manual_unread_message_index, null)) {
                this.manual_unread_message_index = previous_index;
            }
            this.logUnread("manual-unread-clear-failed", {
                previous_index,
                error: error?.message,
            });
        }
    }

    /**
     * Advance or drop the Mongo manual-unread marker from Pinia last-read.
     * No-op unless this viewer marked the conversation unread.
     * Does not wait to catch Twilio (Twilio is never rewound).
     * Queues the furthest cursor and writes one request at a time.
     *
     * @param {number|null} local_last_read
     * @param {{ignore_hold?: boolean}} options
     * @returns {Promise<void>}
     */
    persistManualUnreadAfterAdvance(local_last_read, {ignore_hold = false} = {}) {
        if (this.manual_unread_message_index == null && !this.manual_unread_persist_pump) {
            this.manual_unread_persist_job = null;
            return;
        }

        this.manual_unread_persist_job = coalesceManualUnreadPersist(
            this.manual_unread_persist_job,
            {local_last_read, ignore_hold},
        );

        if (this.manual_unread_persist_pump) {
            return;
        }

        this.manual_unread_persist_pump = this.drainManualUnreadPersists();
    }

    /**
     * @returns {Promise<void>}
     */
    async drainManualUnreadPersists() {
        try {
            while (this.manual_unread_persist_job) {
                const job = this.manual_unread_persist_job;
                this.manual_unread_persist_job = null;

                try {
                    await this.applyManualUnreadPersist(job.local_last_read, {
                        ignore_hold: job.ignore_hold,
                    });
                } catch (error) {
                    this.logUnread("manual-unread-persist-failed", {
                        error: error?.message,
                    });
                }
            }
        } finally {
            this.manual_unread_persist_pump = null;

            if (this.manual_unread_persist_job) {
                this.persistManualUnreadAfterAdvance(
                    this.manual_unread_persist_job.local_last_read,
                    {ignore_hold: this.manual_unread_persist_job.ignore_hold},
                );
            }
        }
    }

    /**
     * @param {number|null} local_last_read
     * @param {{ignore_hold?: boolean}} options
     * @returns {Promise<void>}
     */
    async applyManualUnreadPersist(local_last_read, {ignore_hold = false} = {}) {
        if (this.manual_unread_message_index == null) {
            return;
        }

        const latest_index = this.getLatestMessageTwilioIndex();
        const decision = resolveManualUnreadPersistence({
            manual_message_index: this.manual_unread_message_index,
            last_read_message_index: local_last_read,
            latest_index,
            held: this.hold_visible_read_after_manual_unread,
            ignore_hold,
        });

        this.logUnread("manual-unread-persist", {
            action: decision.action,
            message_index: decision.message_index,
            last_read_message_index: local_last_read,
            latest_index,
            held: this.hold_visible_read_after_manual_unread,
            ignore_hold,
            previous_manual_index: this.manual_unread_message_index,
        });

        if (decision.action === "delete") {
            await this.clearManualUnreadMarker();
            this.clearManualUnreadHold();
            // Separator is frozen on purpose while unread; once caught up it must
            // go or a later own message can briefly sit past store last-read and
            // pick up --unread-range after ListenNewMessage assigns its index.
            useConversation().clearUnreadSeparator(this.id);
            return;
        }

        if (decision.action === "put") {
            await this.updateManualUnreadMarker(decision.message_index);
        }
    }

    /**
     * Persist a new first-unread index without rewinding Twilio.
     *
     * @param {number} message_index
     * @returns {Promise<void>}
     */
    async updateManualUnreadMarker(message_index) {
        if (message_index == null || !this.id) {
            return;
        }

        const previous_index = this.manual_unread_message_index;
        this.manual_unread_message_index = message_index;

        try {
            await axios.put(`/conversations/${this.id}/manual-unread`, {
                message_index,
            });
            this.logUnread("manual-unread-advanced", {
                previous_index,
                message_index,
            });
        } catch (error) {
            if (shouldRevertManualUnreadMarker(this.manual_unread_message_index, message_index)) {
                this.manual_unread_message_index = previous_index;
            }
            this.logUnread("manual-unread-advance-failed", {
                previous_index,
                message_index,
                error: error?.message,
            });
        }
    }

    /**
     * Sync live unread count + Attention Queue after a local-only read advance
     * (Twilio was not rewound for manual unread, so skip path must still clear AQ).
     *
     * @param {number|null} last_read_message_index
     */
    syncLocalUnreadCountAfterAdvance(last_read_message_index) {
        const latest_index = this.getLatestMessageTwilioIndex();
        const unread_count = unreadCountAfterLastRead(
            latest_index,
            last_read_message_index,
        );

        this.unreadMessagesCount = unread_count;
        this.updateUnreadMessagesCount();
        this.syncUnreadIndicator({
            last_read_message_index,
            unread_count,
        });

        useConversation().addUnreadConversation(unread_count, {
            id: this.id,
            itemId: this.itemId,
            name: this.name,
            lastMessageDateCreated:
                this.getTwilioConversation()?.lastMessage?.dateCreated,
        });

        if (unread_count === 0) {
            useConversation().clearUnreadSeparator(this.id);
        }

        this.logUnread("local-unread-synced", {
            last_read_message_index,
            latest_index,
            unread_count,
        });
    }

    /**
     * After messages are loaded, derive unread from last-read vs loaded rows
     * so a stale Twilio getUnreadMessagesCount cannot keep ghost AQ entries.
     *
     * @returns {number}
     */
    syncUnreadCountFromLoadedMessages() {
        const last_read_message_index = this.currentUserLastReadMessageIndex();
        const unread_count = countMessagesAfterLastRead(
            this.state.messages,
            last_read_message_index,
        );

        this.unreadMessagesCount = unread_count;
        this.updateUnreadMessagesCount();
        this.syncUnreadIndicator({
            last_read_message_index,
            unread_count,
        });

        if (unread_count === 0) {
            useConversation().clearUnreadSeparator(this.id);
        }

        this.logUnread("loaded-unread-synced", {
            last_read_message_index,
            latest_index: this.getLatestMessageTwilioIndex(),
            unread_count,
            loaded_messages: this.getTotalLoadedMessages(),
        });

        return unread_count;
    }

    /**
     * Drop sticky AQ entries when local last-read already covers what the user
     * can read (stale Twilio count, or only own messages past the separator).
     *
     * @param {string} reason
     * @returns {boolean} whether unread/AQ was reconciled
     */
    reconcileStaleUnreadForActivityQueue(reason = "reconcile") {
        if (!(this.unreadMessagesCount > 0)) {
            return false;
        }

        const last_read = this.currentUserLastReadMessageIndex();
        const latest = this.getLatestMessageTwilioIndex();
        const separator_after_index = this.unreadSeparatorIndex();
        const first_user_unread = this.firstUnreadMessageForSeparator();
        const loaded_messages = this.getTotalLoadedMessages();
        const reconcile_to = resolveStaleActivityQueueUnreadReconcile({
            unread_messages_count: this.unreadMessagesCount,
            last_read_message_index: last_read,
            latest_index: latest,
            first_user_unread_index: first_user_unread?.index ?? null,
            separator_after_index,
            loaded_messages,
        });

        this.logUnread("unread-reconcile", {
            reason,
            last_read,
            latest,
            reconcile_to,
            previous_unread: this.unreadMessagesCount,
            first_user_unread_index: first_user_unread?.index ?? null,
            separator_after_index,
            loaded_messages,
        });

        if (reconcile_to == null) {
            return false;
        }

        // Persist Twilio horizon as well as local AQ — local-only advance left
        // never-read conversations sticky across refresh.
        this.updateAuthorsLastReadMessageIndexWith(
            reconcile_to,
            false,
            reason,
        );
        return true;
    }

    setPendingMessageToJump(msg) {
        this.state.pending_message_to_jump = msg;
    }

    boardNameIfContextual() {
        if (!this.isContextual()) return "";
        const item = getItemById(this.itemId);

        return item?.board_name;
    }

    getMesssageTyped() {
        return getDraftForConversation(this.sid);
        // return this.state.messageTyped ? this.state.messageTyped: '';
    }

    setMessageTyped(message) {
        // this.state.messageTyped = message
        updateCurrentConversationDraft(message);
    }

    getUserId() {
        return this.authUser.user_id;
    }

    authorName() {
        return this.authUser.user_name;
    }

    getUserIdentity() {
        return this.auth_user_chat_identity;
    }

    getParticipants() {
        return this.state.participants;
    }

    getActiveParticipats() {
        return this.getParticipants().filter(
            (profile) => profile.is_removed == false,
        );
    }

    removeParticipantById(id) {
        const participant = this.getParticipants().find(
            (profile) => profile.id == id,
        );
        if (participant) {
            participant.is_removed = true;
        }
    }

    getParticipantById(id) {
        return this.getParticipants().find((profile) => profile.id == id);
    }

    getActiveParticipantsExcept(id) {
        return this.getParticipants().filter(
            (profile) => profile.is_removed == false && profile.id != id,
        );
    }

    getOtherActviceParticipats() {
        return this.getParticipants().filter(
            (profile) =>
                profile.is_removed == false &&
                useUserStore().isNotCurrentUser(profile.twilio_identity),
        );
    }

    getActiveParticipantIds() {
        return this.getActiveParticipats().map((profile) => profile.id);
    }

    getActiveParticipantIdsByState() {
        return this.participants.map((profile) => profile.id);
    }

    getParticipantIds() {
        const ids = [];
        this.getParticipants()?.forEach((participant) =>
            ids.push(participant.id),
        );
        return ids;
    }

    getOtherParticipants() {
        let uniqe_participants = new Set();

        return this.state.participants?.filter((participant) => {
            if (
                uniqe_participants.has(participant.id) ||
                participant.twilio_identity == loggedInUserChatIdentity()
            )
                return false;

            uniqe_participants.add(participant.id);
            return true;
        });
    }

    getItemCategory() {
        if (!this.is_item) {
            return null;
        }
        const tree = useWorkspaceTree();
        const item = tree.getItemById(this.originalData?.item?.id);
        if (!item) {
            return null;
        }
        return tree.getItemCategoryById(
            item.itemCategoryId ?? item.item_category_id,
        );
    }

    getOtherActiveParticipants() {
        return this.getOtherParticipants().filter(
            (profile) => profile.is_removed == false,
        );
    }

    getOtherActiveParticipantIds() {
        return this.getOtherParticipants().map((profile) => profile.id);
    }

    filterNewlyInvitedProfilesFromList(updated_participant_profile_ids) {
        const current_participants = this.getActiveParticipats().map(
            (profile) => profile.id,
        );
        const new_profile_ids = updated_participant_profile_ids.filter(
            (x) => !current_participants.includes(x),
        );
        return new_profile_ids;
    }

    filterRemovedProfilesFromList(updated_participant_profile_ids) {
        const current_participants = this.getActiveParticipats().map(
            (profile) => profile.id,
        );
        const deleted_profile_ids = current_participants.filter(
            (x) => !updated_participant_profile_ids.includes(x),
        );
        return deleted_profile_ids;
    }

    getConversationId() {
        return this.state.id;
    }

    getConversationSid() {
        return this.sid;
    }

    getType() {
        return this.state.type;
    }

    isContextual() {
        return this.type == TYPE.ITEM;
    }

    isItem() {
        return this.type == TYPE.ITEM || this.type == TYPE.ITEM_FEEDBACK;
    }

    isBoard() {
        return this.type == TYPE.BOARD;
    }

    isSpace() {
        return this.type == TYPE.SPACE;
    }

    isGroup() {
        return this.type == TYPE.GROUP;
    }

    isDm() {
        return this.type == TYPE.DM;
    }

    isInvitationAllowed() {
        return !this.isDm();
    }

    getName() {
        return this.state.name;
    }

    prepareName() {
        if (this.state.name) return;
        /* even for Fake contexual conversations, default name is set i.e list item naem  */

        if (this.isGroup() || this.isDm() || this.isContextual())
            this.state.name = this.state.name ? this.state.name : "Untitled";
        // for dm
        this.state.name = "Conversation-#";
        const oppositeParticipant = this.getDMParticipant();
        if (oppositeParticipant) {
            this.state.name = `${oppositeParticipant?.name}`; // -${oppositeParticipant.user_email}`
        }
    }

    getDMParticipant() {
        if (this.state.participants.length === 1) {
            return this.state.participants[0];
        }

        const is_agent_dm_conversation = this.state.participants.length === 2;
        const participant = this.state.participants?.find((participant) => {
            const notCurrentUser =
                participant.twilio_identity !== loggedInUserChatIdentity();
            const hasId = Boolean(participant.id);

            if (is_agent_dm_conversation) {
                return notCurrentUser && hasId;
            } else {
                // Only allow non-agent as "other" participant in non-agent DMs
                return (
                    notCurrentUser && hasId && participant.is_agent === false
                );
            }
        });
        return participant || {};
    }

    processingStarted() {
        this.state.isConversationPreparationInProgress = 1;
        if (this.isIndicatorSetToHide()) return;
        this.isCurrentConversation() &&
        (this.didISetCurrentConversationStateToLoading = true) &&
        showConnectingIndicator();
    }

    processingCompleted() {
        this.state.isConversationPreparationInProgress = 0;

        /* to set chat connecting indicator status to false if current conversation was replaced with new current one (fake conversaton) */
        if (
            this.isCurrentConversation() ||
            this.didISetCurrentConversationStateToLoading
        )
            hideConnectingIndicator();
    }

    setHideLoadingIndicatorWith(flag) {
        this.state.hideLoadingIndicator = flag;
    }

    setAssignee(profile_id) {
        this.state.user_profile_id_assignee = profile_id;
    }

    dontShowLoadingIndicators() {
        this.setHideLoadingIndicatorWith(true);
    }

    showLoadingIndicator() {
        this.setHideLoadingIndicatorWith(true);
        showConnectingIndicator();
        this.forceUiUpdate();
    }

    isIndicatorSetToHide() {
        return this.state.hideLoadingIndicator;
    }

    isProcessing() {
        return this.isIndicatorSetToHide()
            ? false
            : this.state.isConversationPreparationInProgress;
    }

    // getChatToken() {
    //     return this.chat_access_token;
    // }

    prepareStatusClassModifier() {
        const errors = ["No Conversation", "offline", "failed"];

        if (errors.includes(this.state.status)) {
            return "prospus-chat-status--offline";
        }
        return "prospus-chat-status--connected";
    }

    setInitialMessagesFetched() {
        this.state.is_initial_messages_fetched = true;

        if (useConversation().active?.id == this.id || this.stop_loader_on_load) {
            useConversation().stopLoader();
        }

        this.removeStopLoaderOnLoad()
    }

    shouldScrollToBottom(){
        return useConversation().active?.id == this.id || this.stop_loader_on_load;
    }

    removeInitialMessagesFetched() {
        this.state.is_initial_messages_fetched = false;
    }

    setStatusToPreparing() {
        this.state.status = "preapring";
        this.processingStarted();
    }

    setStatusToLoadingMessages() {
        this.state.status = "loading messages";
    }

    setStatusToConnecting() {
        this.state.status = "connecting";
    }

    setStatusToConnected() {
        this.state.status = STATUS.CONNECTED;
        this.processingCompleted();
    }

    setStatusReadyToChat() {
        this.state.status = STATUS.CONNECTED;
        this.processingCompleted();
    }

    setStatusToFailed() {
        this.state.status = STATUS.FAILED;
        this.processingCompleted();
    }

    setStatusToOffline() {
        this.state.status = STATUS.OFFLINE;
    }

    updateState(state) {
    }

    isReadyToChat() {
        return this.state.status == STATUS.CONNECTED;
    }

    getStatus() {
        return this.state.status;
    }

    hasTwilioConversationSet() {
        return this.getTwilioConversation();
    }

    hasConversationNotCreated() {
        return !this.getTwilioConversation();
    }

    getTwilioConversation() {
        return this.twilioConversation?.value;
    }

    setTwilioConversation(value) {
        this.twilioConversation.value = value;
    }

    isPlaceHolder() {
        return !this.sid && this.id;
    }

    isNewConversation() {
        return !this.sid;
    }

    setRecentActivePanel(val) {
        this.recent_active_panel = val;
    }

    /*
    1. fake contextual conversation
    2. place holder conversation
    */
    isToShowHint() {
        return (
            !this.areMessagesBuffered() &&
            ((!this.sid && this.id) || this.isFake())
        );
    }

    isFakeEmptyContextualConversation() {
        return this.isContextual() && !this.areMessagesBuffered() && !this.sid;
    }

    async prepare() {
        if (!this.sid)
            return console.log("Empty Conversation..", this.conversationId);
        subscribeWithIdentity(this.auth_user_chat_identity, this);
    }

    setState(newState) {
        this.state = {...this.state, ...newState};
    }

    async onConversationFound(twilioConversation) {
        if (this.hasTwilioConversationSet()) {
            window.logger(
                "twilio connection already exists. Messages will not fetch",
            );
            this.twilioConversation.value = twilioConversation;

            return;
        }

        this.removeInitialMessagesFetched();
        this.setTwilioConversation(twilioConversation);
        //this.state.twilioConversation = twilioConversation;
        this.setUpAndPrepareRequiredFields();

        // if (this.isToSendBoardMessage)
        //     this.sendBoardInvitationMessages()
        //
        // if (this.isToSendGroupMessage)
        //     this.sendGroupInvitationMessages()

        //        this.state.is_clear_messages && await new Promise(resolve => setTimeout(resolve, 2000));

        this.sendUnsendMessages();
        await this.sendBufferedMessages();

        window.logger("fetch started ", twilioConversation.sid);
        this.state.total_messages =
            await this.getTwilioConversation().getMessagesCount();
        this.fetchMessages();
        //this.state.bufferedMessages = []

        this.registerRequiredHandleraWithConversation();
        this.registerForParticipantEvents();
        this.sendMessageToNotifyWithCurrentUrl();
        // this.setupUrgentRequests();
    }

    // setupUrgentRequests() {
    //     return ;

    //     this.state.urgent_request =
    //         this.getTwilioConversation()?.attributes?.urgent_request ?? [];

    //     useRequest().updateUrgentRequest(this.state.urgent_request);
    // }

    sendUnsendMessages() {
        const restore_state =
            useConversation().buffered_restore_conversation?.find(
                (state) => state.id === this.state.id,
            );

        if (!restore_state) return;

        restore_state.unsend_messages?.forEach((message) => {
            this.processToSendConversation(
                message.body,
                message.attributes,
                message,
                (messageIndex) => {
                    if (messageIndex > -1) message.index = messageIndex;

                    message.is_proceesing = false;

                    this.updateLastReadUsersForMessages();
                },
                () => {
                    message.is_proceesing = true;
                    restore_state.messages[message.temp_index] = {
                        ...restore_state.messages[message.temp_index],
                        is_proceesing: true,
                        temp_index: message.temp_index,
                    };
                },
            );
        });
    }

    setupUrgentRequestsKaamfu(model_req) {
        if (model_req) {
            model_req.forEach((req) => {
                useRequest().setUrgentRequestByPush(req);
            });
            //useRequest().updateUrgentRequest(this.state.urgent_request)
        } else useRequest().setUrgentRequest([]);
    }

    registerRequiredHandleraWithConversation() {
        if (this.hasAlredyRegisteredForMessageAddedEvent()) return;

        this.listenForParticipantLeft();
        this.listenForParticipantJoined();
        this.listenForNewMessage();
        this.registerForTypeHinting();
        this.registeringHandlersCompleted();
        this.listenForUpdateMessage();
    }

    async fetchTwilioParticipants(is_to_move_scrollbar = false) {
        if (this.hasConversationNotCreated()) return;
        const participants = await this.getTwilioConversation().getParticipants();
        // console.log("updating participants lastReadMessageIndex for " , this.getName())
        participants.forEach((participant) => {
            this.updateParticipantLastReadMessageIndex(participant);
        });
        this.updateLastReadUsersForMessages();
        this.syncUnreadIndicator();
        // this.moveScrollBar();
    }

    updateParticipantLastReadMessageIndex(participant) {
        const userDetails = this.findParticipantByIdentity(
            participant.identity,
        );
        if (!userDetails) return;
        userDetails.last_read_message_index = participant.lastReadMessageIndex;
        // console.log( "Updating for participant : ", userDetails , participant.lastReadMessageIndex)
    }

    /** Debug trace of the read / unread line sequence. */
    logUnread(event, details = {}) {
       /* console.log(
             `[Unread:${event}]`,
             JSON.stringify({
                 conversation_id: this.id,
                 ...details,
             }),
         );*/
    }

    currentUserLastReadMessageIndex() {
        const participant_index =
            this.findParticipantByIdentity(this.auth_user_chat_identity)
                ?.last_read_message_index ?? null;
        const stored_index =
            useConversation().getUnreadIndicator(this.id)
                ?.last_read_message_index ?? null;

        // Manual unread never rewinds Twilio. Prefer the local visit cursor so
        // viewport reads can advance and the highlight can shrink; Math.max
        // with the Twilio participant would leave the store stuck behind.
        if (this.manual_unread_message_index != null) {
            return stored_index ?? participant_index;
        }

        if (participant_index == null) return stored_index;
        if (stored_index == null) return participant_index;

        return Math.max(participant_index, stored_index);
    }

    /**
     * Push the current read position and unread count into the conversation
     * store, which owns the unread line state for the whole app.
     */
    syncUnreadIndicator(values = {}) {
        if (!this.id) return null;

        const indicator = useConversation().syncUnreadIndicator(this.id, {
            last_read_message_index: this.currentUserLastReadMessageIndex(),
            unread_count: this.unreadMessagesCount,
            ...values,
        });

        this.logUnread("indicator", {
            ...indicator,
            overrides: values,
        });

        return indicator;
    }

    /**
     * Read position this visit starts from. Twilio keeps it on the conversation
     * itself, which is already loaded, while participant data needs a request
     * that usually resolves after the first messages are on screen.
     */
    visitReadAnchorIndex() {
        return (
            this.getTwilioConversation()?.lastReadMessageIndex ??
            this.currentUserLastReadMessageIndex()
        );
    }

    /**
     * Place the "New Messages" line for this visit. Must run before messages
     * render, because reading them pushes the read position forward.
     * Merges Twilio last-read with any per-user manual unread marker.
     */
    seedUnreadIndicator() {
        // Drop any leftover hold from a previous visit, then re-arm below when
        // a manual marker is still active so a short thread cannot auto-clear.
        this.clearManualUnreadHold();

        const twilio_anchor = this.visitReadAnchorIndex();
        const manual_message_index = this.manual_unread_message_index;
        const twilio_unread = this.unreadMessagesCount ?? 0;

        this.logUnread("seed", {
            anchor_index: twilio_anchor,
            unread_count: twilio_unread,
            manual_unread_message_index: manual_message_index,
        });

        const should_apply_manual =
            manual_message_index != null &&
            (twilio_unread === 0 ||
                twilio_anchor == null ||
                manual_message_index <= twilio_anchor);

        if (should_apply_manual) {
            this.pending_never_read_separator_refine = false;

            const new_last_read =
                manual_message_index <= 0 ? -1 : manual_message_index - 1;
            const unread_count = this.computeManualUnreadCount(
                manual_message_index,
            );

            const participant = this.findParticipantByIdentity(
                this.auth_user_chat_identity,
            );
            if (participant) {
                participant.last_read_message_index =
                    new_last_read < 0 ? null : new_last_read;
            }

            this.unreadMessagesCount = Math.max(twilio_unread, unread_count);
            this.updateUnreadMessagesCount();

            this.syncUnreadIndicator({
                last_read_message_index:
                    new_last_read < 0 ? null : new_last_read,
                unread_count: this.unreadMessagesCount,
                force_unread: true,
            });

            useConversation().addUnreadConversation(this.unreadMessagesCount, {
                id: this.id,
                itemId: this.itemId,
                name: this.name,
                lastMessageDateCreated:
                    this.getTwilioConversation()?.lastMessage?.dateCreated,
            });

            // Short threads fit on screen; without a hold, settle recheck would
            // immediately mark through latest and wipe the manual line.
            this.armManualUnreadHold();

            return useConversation().getUnreadIndicator(this.id);
        }

        const effective_anchor = effectiveLastReadMessageIndex(
            twilio_anchor,
            manual_message_index,
        );

        // Never-read / last-read 0: defer the separator until messages load so
        // we can anchor on the current user's invite instead of always -1.
        if (twilio_anchor == null || twilio_anchor === 0) {
            this.pending_never_read_separator_refine =
                (this.unreadMessagesCount ?? 0) > 0;

            const indicator = this.syncUnreadIndicator({
                last_read_message_index: effective_anchor,
            });

            this.refineNeverReadSeparatorIfNeeded();

            return (
                useConversation().getUnreadIndicator(this.id) ?? indicator
            );
        }

        this.pending_never_read_separator_refine = false;

        return this.syncUnreadIndicator({
            last_read_message_index: effective_anchor,
            seed_separator: true,
        });
    }

    /**
     * Place the never-read New Messages line above the latest invite that
     * includes the current user, once messages are loaded. No match → no line.
     */
    refineNeverReadSeparatorIfNeeded() {
        if (!this.pending_never_read_separator_refine) {
            return;
        }

        if (this.manual_unread_message_index != null) {
            this.pending_never_read_separator_refine = false;
            return;
        }

        if (!(this.unreadMessagesCount > 0)) {
            this.pending_never_read_separator_refine = false;
            return;
        }

        if (!this.state.messages?.length) {
            return;
        }

        const is_dm = this.isDm();
        const message_count =
            this.state.total_messages || this.getTotalLoadedMessages();

        // Must run before invite matching: short non-DM threads highlight all.
        if (message_count === 2 && !is_dm) {
            this.pending_never_read_separator_refine = false;
            this.logUnread("never-read-two-message", {
                separator_after_index: -1,
                message_count,
                is_dm,
                loaded_messages: this.getTotalLoadedMessages(),
            });
            this.syncUnreadIndicator({
                last_read_message_index: null,
                unread_count: this.unreadMessagesCount,
                force_unread: true,
            });
            return;
        }

        const current_user_profile_id =
            useUserStore().getCurrentUserProfileId();
        const separator_after_index = findNeverReadInviteSeparatorAfterIndex(
            this.state.messages,
            current_user_profile_id,
            {message_count, is_dm},
        );

        this.pending_never_read_separator_refine = false;

        this.logUnread("never-read-invite", {
            separator_after_index,
            current_user_profile_id,
            message_count,
            is_dm,
            loaded_messages: this.getTotalLoadedMessages(),
        });

        if (separator_after_index == null) {
            return;
        }

        if (separator_after_index < 0) {
            // force_unread clears a prior last-read of 0 so highlight-all works
            // (plain seed_separator leaves last_read unchanged when next is null).
            this.syncUnreadIndicator({
                last_read_message_index: null,
                unread_count: this.unreadMessagesCount,
                force_unread: true,
            });
            return;
        }

        this.syncUnreadIndicator({
            last_read_message_index: separator_after_index,
            seed_separator: true,
        });
    }

    unreadSeparatorIndex() {
        return useConversation().getUnreadSeparatorIndex(this.id);
    }

    firstUnreadMessageForSeparator() {
        const separator_after_index = this.unreadSeparatorIndex();
        if (separator_after_index == null) return null;

        // Twilio seeds skip the user's own messages (they are never "new" to
        // read). A manual mark may target the user's own message, so keep it.
        return findFirstUnreadMessage(this.state.messages, separator_after_index, {
            ignore_own_messages: this.manual_unread_message_index == null,
        });
    }

    isFirstUnreadSeparatorMessage(message) {
        const first_unread = this.firstUnreadMessageForSeparator();

        return Boolean(
            first_unread?.sid && message?.sid && first_unread.sid === message.sid,
        );
    }

    /**
     * True for loaded messages still unread after the New Messages line.
     * Shrinks as last_read advances; separator_after_index stays frozen.
     *
     * @param {{index?: number}|null|undefined} message
     * @returns {boolean}
     */
    isMessageInUnreadSeparatorRange(message) {
        const separator_after_index = this.unreadSeparatorIndex();
        if (separator_after_index == null || message?.index == null) {
            return false;
        }

        // Match Message.vue: seed/AQ never paints own rows; manual mark may.
        if (
            message.is_author &&
            this.manual_unread_message_index == null
        ) {
            return false;
        }

        if (message.index <= separator_after_index) {
            return false;
        }

        const last_read_message_index =
            useConversation().getUnreadIndicator(this.id)
                ?.last_read_message_index ?? null;

        if (
            last_read_message_index != null &&
            message.index <= last_read_message_index
        ) {
            return false;
        }

        return true;
    }

    /**
     * Scroll to the "New Messages" line instead of the bottom of the list.
     *
     * @returns {boolean} whether the scroll was requested
     */
    requestScrollToFirstUnreadMessage() {
        if (
            useConversation().hasHigherPriorityScrollReservation(
                this,
                MESSAGE_SCROLL_REASONS.UNREAD,
            )
        ) {
            this.logUnread("scroll-skipped", {
                cause: "higher priority scroll reserved",
            });
            return false;
        }

        const first_unread = this.firstUnreadMessageForSeparator();
        if (!first_unread?.sid) {
            this.logUnread("scroll-skipped", {
                cause: "no unread message to scroll to",
                separator_after_index: this.unreadSeparatorIndex(),
                loaded_messages: this.getTotalLoadedMessages(),
            });

            if (this.unreadMessagesCount > 0) {
                this.reconcileStaleUnreadForActivityQueue(
                    "scroll-skipped-no-first-unread",
                );
            }

            return false;
        }

        this.logUnread("scroll-to-unread", {
            message_sid: first_unread.sid,
            message_index: first_unread.index,
        });

        return this.requestScrollToMessage(
            first_unread.sid,
            MESSAGE_SCROLL_REASONS.UNREAD,
        );
    }

    isScrolledNearBottom(threshold = 120) {
        // Shared chat scroller belongs to the active conversation only.
        if (!this.isCurrentConversation()) {
            return false;
        }

        const container = document.querySelector(
            ".prospus-messages-container__wrapper",
        );
        if (!container) return false;

        return (
            container.scrollHeight -
            container.scrollTop -
            container.clientHeight <=
            threshold
        );
    }

    /**
     * Whether settle-then-ack / AQ reconcile may run for this handler.
     *
     * @returns {boolean}
     */
    shouldRunVisibleUnreadAcknowledgement() {
        return shouldRunVisibleUnreadAcknowledgement({
            is_current: this.isCurrentConversation(),
            is_conversation_open: useAppState().is_conversation_open,
            is_message_tab: useChat().is_message_tab,
        });
    }

    async fetchMessages() {
        this.setStatusToLoadingMessages();
        await this.fetchTwilioParticipants();
        // Bootstrap only — overwritten after messages load from last-read.
        this.unreadMessagesCount =
            await this.getTwilioConversation().getUnreadMessagesCount();
        if (this.unreadMessagesCount == null) {
            this.unreadMessagesCount = this.state.total_messages;
        }
        this.updateUnreadMessagesCount();
        this.seedUnreadIndicator();

        const jump = this.state.pending_message_to_jump;
        if (jump) {
            this.state.pending_message_to_jump = null;
            this.jumpToMessage(jump.id, jump.index);
            return;
        }

        this.getTwilioConversation()
            .getMessages(this.MESSAGES_CHUNK_SIZE)
            .then((messagePaginator) => {
                //  if there are any messages before conversation has loaded. push it at the end.

                const current_messages = this.state.messages;
                this.state.messages = [];
                messagePaginator.items.forEach((message, index) => {
                    this.addNewMessage(
                        message,
                        this.parseTwilioMessageBody(message),
                    );
                });

                if (!this.state.is_clear_messages) {
                    current_messages.forEach((message) => {
                        this.state.messages.push(message);
                    });
                }

                if (this.isCurrentConversation())
                    console.log(
                        "message fetched for conversation ",
                        this.state.name,
                        Date.now(),
                    );

                if (this.MESSAGES_CHUNK_SIZE === messagePaginator.items.length)
                    this.state?.messages?.splice(0, 1);

                this.clearCachedMessages();
                this.setStatusReadyToChat();

                this.syncUnreadCountFromLoadedMessages();
                this.refineNeverReadSeparatorIfNeeded();

                this.logUnread("messages-fetched", {
                    loaded_messages: this.getTotalLoadedMessages(),
                    unread_count: this.unreadMessagesCount,
                    should_scroll_to_bottom: this.shouldScrollToBottom(),
                });

                if (
                    this.shouldScrollToBottom() &&
                    !this.requestScrollToFirstUnreadMessage()
                ) {
                    this.logUnread("scroll-to-bottom", {
                        cause: "no unread line to land on",
                    });
                    useChat().scrollToBottom();
                }
                this.setInitialMessagesFetched();
                this.setUnreadMessagesCountFromFetchedMessages();
                this.updateLastReadUsersForMessages();
                this.moveScrollBar();
                this.removeAsArchivedConversation();

                const first_unread_message = this.firstUnReadMessage();
                const is_manual_unread = this.manual_unread_message_index != null;
                useConversation().addUnreadConversation(
                    this.unreadMessagesCount,
                    {
                        id: this.id,
                        itemId: this.itemId,
                        name: this.name,
                        // Manual unread must still enter AQ when the marked
                        // message is the viewer's own. Passing author makes
                        // addUnreadConversation skip that add.
                        author: is_manual_unread
                            ? undefined
                            : first_unread_message?.author,
                        type: is_manual_unread
                            ? undefined
                            : first_unread_message?.type,
                        lastMessageDateCreated:
                            this.getTwilioConversation().lastMessage
                                ?.dateCreated,
                    },
                );
                if (this.shouldRunVisibleUnreadAcknowledgement()) {
                    this.scheduleVisibleUnreadAcknowledgement(
                        "messages-fetched",
                    );
                }
                this.state.message_fetching_attempt = 0;
            })
            .catch((err) => {
                this.state.message_fetching_attempt += 1;
                if (this.state.message_fetching_attempt >= 2) {
                    console.error("Couldn't fetch messages", err);
                    this.setState({loadingState: "failed"});
                    this.setInitialMessagesFetched();
                    this.setStatusToFailed();
                    return;
                }

                window.logger(
                    "Message fetch failed. Retrying " +
                    this.state.message_fetching_attempt,
                );
                this.fetchMessages();
            });
    }

    async loadMoreMessages(
        number_of_messages = 25,
        end_message_index = this.state?.messages?.[0]?.index,
    ) {
        if (
            !end_message_index ||
            this.state.isLoadingMoreMessages ||
            !this.hasTwilioConversationSet()
        )
            return;

        this.state.isLoadingMoreMessages = true;
        this.state.lastMessageIndexFromNewlyLoadedMessages = end_message_index;

        try {
            const t0 = performance.now();
            const messagePaginator =
                await this.getTwilioConversation().getMessages(
                    number_of_messages,
                    end_message_index,
                );

            const newMessages = [];
            messagePaginator.items.forEach((message) => {
                if (end_message_index != message.index) {
                    message.isToSkipSplice = true;
                    const msgObj = this.addNewMessage(
                        message,
                        this.parseTwilioMessageBody(message),
                        false,
                    );
                    if (msgObj) {
                        newMessages.push(msgObj);
                    }
                }
            });

            if (newMessages.length > 0) {
                this.state.messages.splice(0, 0, ...newMessages);
                for (let i = 0; i <= newMessages.length; i++) {
                    if (this.state.messages[i]) {
                        this.updateMessageAuthorAndTimestamp(
                            i,
                            this.state.messages[i],
                        );
                        this.checkPreviousNextEventMessage(
                            i,
                            this.state.messages[i],
                        );
                    }
                }
                this.moveScrollBar(false);
            }
            const t1 = performance.now();
            console.log(
                `[loadMoreMessages] API call took ${(t1 - t0).toFixed(1)}ms — anchor index: ${end_message_index}, fetched: ${messagePaginator.items.length}`,
            );

            this.setLoadingMoreMessagesTimeOut();
            return true;
        } catch (err) {
            console.error("Couldn't fetch messages IMPLEMENT RETRY", err);
            this.state.isLoadingMoreMessages = false;
            return false;
        }
    }

    // getTwillioMessages(number_of_messages = this.MESSAGES_CHUNK_SIZE, end_message_index = null) {
    //     return this.twilioConversation.getMessages(number_of_messages, end_message_index)
    // }

    setLoadingMoreMessagesTimeOut() {
        clearTimeout(this.loadingMoreMessagesTimeOut);

        this.loadingMoreMessagesTimeOut = setTimeout(() => {
            //this.state.isLoadingMoreMessages = false;
            this.state.lastMessageIndexFromNewlyLoadedMessages = null;
            clearTimeout(this.loadingMoreMessagesTimeOut);
        }, 600);
    }

    // mute() {
    //     this.isMuted = true;
    // }

    incrementUnreadMessagesCount() {
        this.unreadMessagesCount =
            this.unreadMessagesCount == null ? 0 : this.unreadMessagesCount;
        ++this.unreadMessagesCount;
        this.updateUnreadMessagesCount();
        //this.isMuted = false;
    }

    setUnreadMessagesCountFromFetchedMessages() {
        if (this.unreadMessagesCount != null || !this.state.messages.length)
            return;

        this.unreadMessagesCount = this.getLatestMessageTwilioIndex();
        this.updateUnreadMessagesCount();
    }

    updateUnreadMessagesCount() {
        if (!this.sid) return;
        updateUnreadMessagesCountBy(this.sid, this.unreadMessagesCount);
    }

    getLastMessage() {
        return this.state.messages[this.state.messages.length - 1];
    }

    getLatestMessageTwilioIndex() {
        return this.getLastMessage()?.index;
    }

    sendBoardInvitationMessages() {
        let authUser = this.authUser;
        let names = "";
        let ctr = 1;

        this.participants?.forEach((v) => {
            if (authUser.id != v.id) {
                if (this.participants.find((ov) => v.id === ov.id)) {
                    names += "&#x2022; " + v.name + " <br />";
                }
            }
            ctr++;
        });

        const newMessage =
            authUser.first_name +
            " Created Board : <br /> " +
            authUser.first_name +
            " has added: <br />" +
            names;
        this.sendMessage(newMessage);
    }

    markMessagesAsRead(is_to_update_authors = false) {
        if (
            !is_to_update_authors &&
            (!this.state.messages?.length || !this.unreadMessagesCount)
        )
            return;

        const lastMessageIndex = this.getLatestMessageTwilioIndex();

        if (lastMessageIndex == null) return;

        this.updateAuthorsLastReadMessageIndexWith(
            lastMessageIndex,
            false,
            "mark-messages-as-read",
        );
    }

    /**
     * Advance the read position for a message that the user actually has in the
     * message list viewport.
     *
     * @param {number|null} message_index Twilio message index
     * @returns {boolean} whether the read position moved
     */
    markVisibleMessageAsRead(message_index) {
        if (message_index == null || !this.hasTwilioConversationSet()) {
            return false;
        }

        if (
            !this.isCurrentConversationAndChatPanelOpened() ||
            !useChat().is_message_tab
        ) {
            this.logUnread("visible-ignored", {
                message_index,
                cause: "conversation or message tab not open",
            });
            return false;
        }

        if (this.isVisibleReadSuppressed()) {
            this.logUnread("visible-ignored", {
                message_index,
                cause: this.visibleReadSuppressCause(),
                pending_scroll_to_sid: this.state.pending_scroll_to_sid,
                suppress_until: this.suppress_visible_read_until,
                held: this.hold_visible_read_after_manual_unread,
            });
            return false;
        }

        const last_read_message_index = this.currentUserLastReadMessageIndex();
        if (
            last_read_message_index != null &&
            message_index <= last_read_message_index
        ) {
            this.logUnread("visible-ignored", {
                message_index,
                last_read_message_index,
                cause: "already read",
            });
            return false;
        }

        this.logUnread("visible-read", {
            message_index,
            last_read_message_index,
        });

        this.syncUnreadIndicator({last_read_message_index: message_index});

        // Scrolling makes many messages visible at once; Twilio only needs the
        // highest index of the burst.
        this.pending_visible_read_index = Math.max(
            this.pending_visible_read_index ?? message_index,
            message_index,
        );

        // Debounced flush (was 400ms) — disabled for faster AQ / local unread.
        // clearTimeout(this.visible_read_timeout);
        // this.visible_read_timeout = setTimeout(() => {
        const last_visible_index = this.pending_visible_read_index;
        this.pending_visible_read_index = null;
        this.visible_read_timeout = null;

        if (this.isVisibleReadSuppressed()) {
            this.logUnread("visible-read-flush-cancelled", {
                message_index: last_visible_index,
                cause: "unread scroll settle",
            });
            return true;
        }

        if (last_visible_index != null) {
            this.logUnread("visible-read-flush", {
                message_index: last_visible_index,
            });
            this.updateAuthorsLastReadMessageIndexWith(
                last_visible_index,
                false,
                "visible-read-flush",
            );
        }
        // }, 400);

        return true;
    }

    updateAuthorsLastReadMessageIndexWith(
        lastMessageIndex,
        isAuthorsMessage = false,
        source = "unknown",
    ) {
        // const unreadMessagesCount = this.unreadMessagesCount;
        // this.unreadMessagesCount = 0

        if (!this.hasTwilioConversationSet()) {
            return;
        }

        const twilio_conversation = this.getTwilioConversation();
        const twilio_last_read = twilio_conversation?.lastReadMessageIndex ?? -1;
        const latest_index = this.getLatestMessageTwilioIndex();

        // Manual unread leaves Twilio ahead of the local cursor. If the thread
        // bottom is already on screen, IO may not report every trailing message
        // (threshold / partial cells). Treat near-bottom as read through latest
        // only after the user has released the manual-unread hold.
        let effective_index = lastMessageIndex;
        if (
            this.manual_unread_message_index != null &&
            !this.hold_visible_read_after_manual_unread &&
            latest_index != null &&
            this.isScrolledNearBottom() &&
            (effective_index == null || effective_index < latest_index)
        ) {
            this.logUnread("near-bottom-catch-up", {
                from_index: effective_index,
                to_index: latest_index,
                source,
            });
            effective_index = latest_index;
        }

        this.logUnread("twilio-update", {
            last_read_message_index: effective_index,
            is_authors_message: isAuthorsMessage,
            source,
            twilio_last_read,
        });

        // Always advance the local participant / store for the re-read span.
        const participant = this.findParticipantByIdentity(
            this.auth_user_chat_identity,
        );
        if (participant && effective_index != null) {
            const current = participant.last_read_message_index;
            if (current == null || effective_index > current) {
                participant.last_read_message_index = effective_index;
            }
        }

        // Own messages used to skip Pinia sync; the optimistic→Twilio replace
        // then arrived with store last-read still behind and a frozen
        // separator, so the new own row got --unread-range for ~1s.
        if (effective_index != null) {
            this.syncUnreadIndicator({
                last_read_message_index: effective_index,
            });
        }

        // Never rewind Twilio; only advance past its current last-read.
        if (effective_index == null || effective_index <= twilio_last_read) {
            this.logUnread("twilio-update-skipped", {
                last_read_message_index: effective_index,
                twilio_last_read,
                cause: "advance-only",
            });

            if (!isAuthorsMessage) {
                this.syncLocalUnreadCountAfterAdvance(effective_index);
            } else {
                this.updateUnreadMessagesCount();
            }

            this.persistManualUnreadAfterAdvance(effective_index, {
                ignore_hold: source === "aq-click-step",
            });
            return;
        }

        this.persistManualUnreadAfterAdvance(effective_index, {
            ignore_hold: source === "aq-click-step",
        });

        // AQ / local unread must not wait on Twilio. Twilio's unreadMessagesCount
        // is only available after updateLastReadMessageIndex resolves — use the
        // same local compute + addUnreadConversation path as the skip branch.
        if (!isAuthorsMessage) {
            this.syncLocalUnreadCountAfterAdvance(effective_index);
        } else {
            this.updateUnreadMessagesCount();
        }

        twilio_conversation
            .updateLastReadMessageIndex(effective_index)
            .then((unreadMessagesCount) => {
                this.logUnread("twilio-updated", {
                    last_read_message_index: effective_index,
                    unread_count: unreadMessagesCount,
                    is_authors_message: isAuthorsMessage,
                });

                if (!isAuthorsMessage) {
                    this.unreadMessagesCount = unreadMessagesCount;
                    this.syncUnreadIndicator({
                        last_read_message_index: effective_index,
                    });
                }

                this.updateUnreadMessagesCount();
            })
            .catch(() => {
                this.logUnread("twilio-update-failed", {
                    last_read_message_index: effective_index,
                });
                console.log("not able to update last read message index");
            });
    }

    lastReadParticipantsForMessageAt(messageAt) {
        const currentMessage = this.state.messages[messageAt];
        const currentMessageIndex = currentMessage?.index;
        const nextMessageIndex = this.state.messages[messageAt + 1]?.index;
        const messageAuthorName = this.getMessageAuthorName(currentMessage);

        /* console.log( "unreadParticipantsForMessageAt: ",  {
                messageAt,
                message:currentMessage.body,
                messageAuthorName,
                message_author_identity: currentMessage.author,
                currentMessageIndex,
                nextMessageIndex
            }); */

        const usersRead = new Set();

        this.twilioParticipants?.forEach((participant) => {
            // const participantName = this.getUserName(participant.identity);
            /* console.log( ` participant `, {
                                        participantName,
                                        participant_identity: participant.identity,
                                        userLastMessageReadIndex : participant.lastReadMessageIndex,
                                        nextMessageIndex,
                                    }) */
            if (participant.last_read_message_index == null) return;
            if (
                participant.last_read_message_index >= currentMessageIndex &&
                (nextMessageIndex == null ||
                    participant.last_read_message_index < nextMessageIndex)
            ) {
                participant.name && usersRead.add(participant.name[0]);
            }
        });

        if (messageAt == this.state.messages.length - 1)
            usersRead.add(loggedInUserName()[0]);

        return Array.from(usersRead);
    }

    updateLastReadUsersForMessages() {
        if (
            this.isLastReadUsersOnMessagesSet ||
            !this.isCurrentConversation() ||
            !this.state.participants?.length ||
            !this.state.messages?.length
        )
            return;
        this.isLastReadUsersOnMessagesSet = true;

        let participants = this.state.participants.filter(
            (participant) =>
                participant.last_read_message_index != null &&
                participant.id != this.getUserId(),
        );
        let currentMessage;
        for (let index = this.state.messages.length - 1; index >= 0; --index) {
            currentMessage = this.state.messages[index];

            participants = participants.filter((participant, index) => {
                if (
                    participant.last_read_message_index >= currentMessage.index
                ) {
                    const set = new Set(currentMessage.last_read_by_users);
                    participant.name && set.add(participant.name[0]);
                    currentMessage.last_read_by_users = [...set];
                    return false;
                }
                return true;
            });
            if (!participants.length) return;
        }
        this.moveScrollBar();
    }

    updateMyLastReadMessage(lastIndexFrom = null) {
        const authorNameFirstChar = this.authorName()[0];
        if (!authorNameFirstChar) return;

        if (lastIndexFrom == null)
            lastIndexFrom = this.state.messages.length - 2;

        for (let index = lastIndexFrom; index >= 0; --index) {
            const index = this.state.messages.last_read_by_users?.filter(
                (userNameFirstChar) => authorNameFirstChar == userNameFirstChar,
            );

            if (index >= 0) {
                this.state.messages.last_read_by_users.splice(index, 1);
                break;
            }
        }
    }

    removeUserFromMessageLastReadUsers(participant) {
        if (this.state.messages.length == 0) return;
        for (let index = this.state.messages.length - 1; index >= 0; --index) {
            const message = this.state.messages[index];
            const previousMessage = this.state.messages[index - 1];
            if (participant?.last_read_message_index >= message.index) {
                const set = new Set(message.last_read_by_users);
                set.delete(participant.name[0]);
                message.last_read_by_users = [...set];
                /* if previous message  */
                if (
                    !(
                        participant.last_read_message_index >=
                        previousMessage?.index
                    )
                )
                    return;
            }
        }
    }

    addUserToMessageLastReadUsers(participant) {
        const lastIndex = this.state.messages.length - 1;
        let message = this.state.messages[lastIndex];
        let nextMessage;
        const participantLastReadMessageIndex =
            participant?.last_read_message_index;
        /* if last message is read, update */
        if (message && participantLastReadMessageIndex >= message.index) {
            const set = new Set(message.last_read_by_users);
            set.add(participant.name[0]);
            message.last_read_by_users = [...set];
            return;
        }
        if (lastIndex == 0) return;
        // check for all messages at indices [0.. length-2]
        for (let index = lastIndex - 2; index >= 0; --index) {
            message = this.state.messages[index];
            nextMessage = this.state.messages[index + 1];

            if (
                message &&
                participantLastReadMessageIndex < nextMessage.index &&
                participantLastReadMessageIndex >= message.index
            ) {
                const set = new Set(message.last_read_by_users);
                set.add(participant.name[0]);
                message.last_read_by_users = [...set];
                return;
            }
        }
    }

    registerForParticipantEvents() {
        this.getTwilioConversation().on("participantJoined", (participant) =>
            this.updateParticipantListIfNewUserInvited(participant),
        );

        this.getTwilioConversation().on("participantUpdated", (event) => {
            // console.log("participantUpdated for : ", this.getUserName(event.participant.identity), event.participant.lastReadMessageIndex)
            const participantUpdated = event.participant;
            const participant = this.findParticipantByIdentity(
                participantUpdated.identity,
            );
            this.removeUserFromMessageLastReadUsers(participant);
            this.updateParticipantLastReadMessageIndex(participantUpdated);
            // participant = this.findParticipantByIdentity(participantUpdated.identity);
            // update read messages users list only for other participants
            if (this.getUserIdentity() != participantUpdated.identity)
                this.addUserToMessageLastReadUsers(participant);
            // this.updateLastReadUsersForMessages()
        });
    }

    async updateParticipantListIfNewUserInvited(participant) {
        if (this.isParticipantNew(participant)) {
            //  const conversationDetails = await fetchConversationById(this.id);
            //  this.setConversationVariables(conversationDetails);
            //  this.forceUiUpdate();
        }
    }

    listenForUpdateMessage() {
        this.getTwilioConversation().on("messageUpdated", (res) => {
            const appStateScreenShot = useAppSateScreenShot();
            if (
                appStateScreenShot.hasScreenShotStarted &&
                !appStateScreenShot.isOpenedFromTeamPanel &&
                res.updateReasons?.includes("body")
            ) {
                appStateScreenShot.trackDeletedImages();
            }
            this.addNewMessage(
                res.message,
                this.parseTwilioMessageBody(res.message),
            );
            //this.updateMessagesMap(res.message, true, res.message.body, 'text', null)
        });
    }

    updateUserInvitationsForActiveEntity() {
        if (!useAppState().is_work) return;

        const workspace = useWorkspace();
        const workspaceTree = useWorkspaceTree();
        const invitation = useInvitation();
        const entityConfigs = {
            "item-group": {
                condition: () =>
                    this.is_item_group &&
                    workspace.is_active_panel_items &&
                    workspaceTree.activeItemCategory?.id === this.type_id,
                entity: () => workspaceTree.activeItemCategory,
                updateStore: workspace.setChinItemGroupProfileIds,
                resourceType: invitation.RESOURCE_TYPES["item-group"],
            },
            board: {
                condition: () =>
                    this.is_board &&
                    workspace.is_active_panel_boards &&
                    workspaceTree.activeBoard?.id === this.type_id,
                entity: () => workspaceTree.activeBoard,
                updateStore: (selected_profile_ids, all_profile_ids) =>
                    workspace.setChinBoardProfileIds(
                        selected_profile_ids,
                        all_profile_ids,
                        this.type_id,
                    ),
                resourceType: invitation.RESOURCE_TYPES.board,
            },
            "board-group": {
                condition: () =>
                    this.is_board_group &&
                    workspace.is_active_panel_boards &&
                    workspaceTree.activeBoardCategory?.id === this.type_id,
                entity: () => workspaceTree.activeBoardCategory,
                updateStore: workspace.setChinBoardGroupProfileIds,
                resourceType: invitation.RESOURCE_TYPES["board-group"],
            },
            workspace: {
                condition: () =>
                    this.is_space &&
                    workspace.is_active_panel_spaces &&
                    workspaceTree.activeWorkspace?.id === this.type_id,
                entity: () => workspaceTree.activeWorkspace,
                updateStore: workspace.setChinSpaceProfileIds,
                resourceType: invitation.RESOURCE_TYPES.workspace,
            },
            "workspace-group": {
                condition: () =>
                    this.is_space_group &&
                    workspace.is_active_panel_spaces &&
                    workspaceTree.activeWorkspaceCategory?.id === this.type_id,
                entity: () => workspaceTree.activeWorkspaceCategory,
                updateStore: workspace.setChinSpaceGroupProfileIds,
                resourceType: invitation.RESOURCE_TYPES["workspace-group"],
            },
        };

        const config = entityConfigs[this.type];

        if (config) {
            if (config.condition && !config.condition()) {
                return;
            }

            const entity = config?.entity();
            if (entity && !isEmpty(entity)) {
                handleInviteApi(
                    {
                        selected_entities: [entity],
                        update_store: config.updateStore,
                    },
                    true,
                    config.resourceType,
                );
            }
        }
    }

    listenForParticipantLeft() {
        this.getTwilioConversation().on(
            "participantLeft",
            async (participant) => {
                if (participant.identity == loggedInUserChatIdentity()) {
                    useConversation().addUnreadConversation(0, {
                        id: this.id,
                    });

                    try {
                        const {data} = await axios.get(
                            `/conversations/${this.id}`,
                        );

                        if (!data?.id) return;

                        useConversation().removeAndUpdateActiveIndexById(
                            this.id,
                            this.isGroup() || this.is_group_one_off(),
                        );
                    } catch (e) {
                        if (e?.response?.data?.type) {
                            this.setAsArchivedConversation();
                            this.setTwilioConversation(null);
                            this.removeAllParticipants();
                        } else {
                            useConversation().removeAndUpdateActiveIndexById(
                                this.id,
                            );
                        }
                        useUserStore().decreaseTwilioConversationCount();
                    }
                }

                this.updateParticipantRemovedStatus(participant.identity);
                setTimeout(() => {
                    this.updateUserInvitationsForActiveEntity();
                }, 1000);
            },
        );
    }

    listenForParticipantJoined() {
        this.getTwilioConversation().on("participantJoined", (participant) => {
            this.updateParticipants(this.id);
        });
    }

    checkTwilioUpdateCondition(res) {
        const reasons = res?.updateReasons;
        const active_conversation = useConversation().active;

        return (
            reasons[0] === "attributes" ||
            (reasons.length === 1 &&
                reasons.find((item) => item === "lastMessage") &&
                active_conversation.id !== this.id)
        );
    }

    async updateParticipants(participants = []) {
        if (!participants.length) {
            const {data} = await axios.get(`/conversations/${this.id}`);

            if (!data?.participants) return;

            participants = data?.participants;
        }

        const new_participants = [];
        participants.forEach((participant) => {
            const current_participant = this.getParticipantByIdentity(
                participant.twilio_identity,
            );
            if (current_participant) {
                participant.last_read_message_index =
                    current_participant.last_read_message_index;
            }
            new_participants.push(participant);
        });
        this.state.participants = new_participants;
    }

    listenForNewMessage() {
        this.getTwilioConversation().on("messageAdded", (message) => {
            const isAuthorsMessage = this.isAuthorsMessage(message);
            const has_images = checkImageExists(message.body);

            const isActiveTab =
                this.isCurrentConversationAndChatPanelOpened() &&
                !(
                    this.isStatusInActive() ||
                    window.isAppInActive ||
                    is_inactive.value
                );
            const is_end_assignment = useConversation().is_end_assignment;
            /*
             *    if tab is active and same user it means message is already pushed. Let wait for sometime for
             *    twillio message respond with index. So, in processNewMessage function it will check for
             *    duplicate.
             * */

            if (is_end_assignment || isAuthorsMessage) {
                useConversation().setIsEndAssignment(false);
                timeOutHelper(async () => {
                    this.processNewMessage(
                        message,
                        isAuthorsMessage,
                        isActiveTab,
                    );

                    const index = this.state.buffered_edited_message.findIndex(
                        (msg) => message.index === msg.index,
                    );

                    if (index !== -1) {
                        const buffered =
                            this.state.buffered_edited_message[index];

                        if (buffered?.attributes?.status === "deleted") {
                            await message.updateAttributes(
                                JSON.stringify({status: "deleted"}),
                            );
                        } else if (
                            buffered &&
                            Object.prototype.hasOwnProperty.call(
                                buffered,
                                "attributes",
                            )
                        ) {
                            await message.updateAttributes(
                                JSON.stringify(buffered.attributes ?? {}),
                            );
                        }

                        await message.updateBody(buffered.body);

                        this.state.buffered_edited_message.splice(index, 1);
                    }

                    const restore_state =
                        useConversation().buffered_restore_conversation?.find(
                            (state) => state.id === this.state.id,
                        );

                    if (
                        restore_state &&
                        restore_state?.unsend_messages?.length > 0
                    ) {
                        const index = restore_state?.unsend_messages?.findIndex(
                            (msg) => message.index === msg.index,
                        );

                        if (index !== -1) {
                            restore_state?.unsend_messages.splice(index, 1);
                        }
                    }
                }, 2000);
                return;
            }
            this.processNewMessage(message, isAuthorsMessage, isActiveTab);

            const appState = useAppState();

            if (has_images && appState.hasScreenShotStarted) {
                const result = grabImageUrls(message.body);
                const newImages = result.map((image) => ({
                    id: image,
                    url: image,
                }));
                appState.setSliderImages([
                    ...appState.slider_images,
                    ...newImages,
                ]);
            }
        });
    }

    processNewMessage(message, isAuthorsMessage, isActiveTab) {
        const messageIndex = this.getMessageIndex(message);
        const currentMessageIndex = this.state.messages.length;
        const is_author_message_exist = isAuthorsMessage && messageIndex !== -1;
        const parsedBody = this.parseTwilioMessageBody(message);
        if ([MESSAGE.STATE, MESSAGE.META].includes(parsedBody?.type)) {
            if (isAuthorsMessage) {
                this.updateAuthorsLastReadMessageIndexWith(
                    message.index,
                    isAuthorsMessage,
                    "state-meta-author",
                );
                this.trashTwilioMessage(message);
            } else this.updateUserStatus(message, parsedBody);
            return;
        }

        if (
            parsedBody?.sub_type === "agent_response" &&
            parsedBody?.is_last_message
        ) {
            const index = this.state.typingUsers.findIndex(
                (typingUser) =>
                    typingUser.identity === parseInt(message.author),
            );

            this.state.typingUsers?.splice(index, 1);
        }

        // add only if it's not authors message
        if (is_author_message_exist) {
            this.messagesNotProcessed.push(message);
            this.updateMessage(this.getMessageFromNotProcessedByIndex(message.index));
        } else this.addNewMessage(message, parsedBody, is_author_message_exist);

        // On an active tab the message only counts as read when the user is at
        // the bottom of the list; scrolled up it stays unread until seen.
        this.logUnread("incoming-message", {
            message_index: message.index,
            is_authors_message: isAuthorsMessage,
            is_active_tab: isActiveTab,
            is_scrolled_near_bottom: this.isScrolledNearBottom(),
        });

        if (isAuthorsMessage || (isActiveTab && this.isScrolledNearBottom())) {
            this.updateAuthorsLastReadMessageIndexWith(
                message.index,
                isAuthorsMessage,
                "incoming-message",
            );
        } else if (!isAuthorsMessage) {
            this.handleMessageReceivedOnNonCurrentConversation(
                this.state.messages[currentMessageIndex],
                isAuthorsMessage,
            );
        }

        const isNameChangeAction =
            parsedBody?.type === "action" &&
            (parsedBody?.sub_type === "group_title_renamed" ||
                parsedBody?.sub_type === "topic_title_renamed");

        if (!isNameChangeAction) {
            updateConversationListOrderingWhenConversationReceivedAMessage(
                this.id,
                is_author_message_exist,
            );
        }
    }

    parseTwilioMessageBody(twilioMessage) {
        if (this.isMessageMedia(twilioMessage)) return;

        try {
            const parsedBody = JSON.parse(twilioMessage.body);
            /**
             * Handle non-exception-throwing cases:
             * Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
             * but... JSON.parse(null) returns null, and typeof null === "object",
             * so we must check for that, too. As null is falsey, so this suffices:
             */
            if (parsedBody && typeof parsedBody === "object") return parsedBody;
        } catch (err) {
        }
    }

    handleMessageReceivedOnNonCurrentConversation(message) {
        // console.log("handleMessageReceivedOnNonCurrentConversation: ", twilioMessage.body);
        // non authors
        if (
            !isSameBoardAndStateItemMove(message) &&
            !isRenamedChatEvents(message) &&
            !isNotesChatEvents(message)
        ) {
            this.incrementUnreadMessagesCount();

            useConversation().addUnreadConversation(this.unreadMessagesCount, {
                id: this.id,
                itemId: this.itemId,
                name: this.name,
                lastMessageDateCreated: message.created_at,
                author: message.author,
                type: message.type,
            });
        }

        if (this.isStatusInActive() || window.isAppInActive) {
            const author = this.getMessageAuthorName(message);
            //  const messageText = this.prepareDisplayableTextForMessage(message);

            // const is_sound = !this.getNonBeepMessageType().includes(message?.data?.type)

            // let is_sound = !this.getNonAttentionQueueSubTypes().includes(
            //     message?.data?.sub_type,
            // );

            let is_sound = this.messageCountsAsActivityQueue(message);

            const current_profile_id = useUserStore().getCurrentUserProfileId();
            const is_task_start_resume_recipient_aq =
                is_sound &&
                isTaskStartOrResumeSubType(message?.data?.sub_type);
            if (
                is_sound &&
                !is_task_start_resume_recipient_aq &&
                useUserStore().hasOnlySubordinateTimerAQEvents(
                    current_profile_id,
                )
            ) {
                const subordinate_ids =
                    useTeamPanel().subordinates.find(
                        (subordinate) =>
                            subordinate.assigner_id == current_profile_id,
                    )?.assignees ?? [];

                is_sound = this.isUnReadMessageFromImmediateSubordinates(
                    1,
                    subordinate_ids,
                    [message],
                );
            }

            if (is_sound) {
                window.notifyWith(
                    this.getName(),

                    this.isDm() ? message.body : `${author} : ${message.body}`,

                    () => {
                        // console.log("callback... on notificaiton click")
                        useConversation().openConversationById(this.id);
                    },
                    is_sound,
                );
            }
        }
    }

    prepareDisplayableTextForMessage(message) {
        if (!message) return "";

        if (this.isMessageMedia(message)) return "Shared Media";

        switch (message.type) {
            case MESSAGE.TEXT:
            case MESSAGE.NAVIGATION:
            case MESSAGE.META:
                return message.body;
            case MESSAGE.TIMER:
                return message?.data?.message;
            case MESSAGE.CONVERSATION:
                return "Conversation " + message?.data?.sub_type;
            case MESSAGE.NOTES:
                return "Notes " + message?.data?.sub_type;
            case MESSAGE.ACTION:
                switch (message?.data?.sub_type) {
                    case "item_moved":
                        return `Item moved from ${message?.data?.old_item_group?.name} To ${message?.data?.new_item_group?.name} `;
                }
                return "";
            case MESSAGE.INVITE:
            case MESSAGE.UNINVITE:
            case MESSAGE.ASSIGN:
            case MESSAGE.UNASSIGN:
            case MESSAGE.ATTENTION:
            case MESSAGE.ATTENTION_CLOSED:
            case MESSAGE.REQUEST_STATUS:
            case MESSAGE.REQUEST_STATUS_CLOSED:
            case MESSAGE.SUPPORT:
            case MESSAGE.SUPPORT_CLOSED:
                let user_string = "";
                if (message?.data?.user_profiles)
                    user_string = message?.data?.user_profiles
                        .map((profile) => profile?.name)
                        .join(", ")
                        .replace(/, ([^,]*)$/, " and $1");

                return `${message?.data?.message} ${user_string}`.trim();
            default:
                return message.body;
        }
    }

    getMessageActionText(parsedBody) {
        return this.prepareDisplayableTextForMessage({
            data: parsedBody,
            ...parsedBody,
        });
    }

    addNewMessageToBeReplaced(message, type = MESSAGE.TEXT) {
        const {name, avatar, is_agent} = this.getMessageAuthorDetail({
            author: this.getUserIdentity(),
        });
        let attributes;

        try {
            attributes = message.attributes
                ? JSON.parse(message.attributes)
                : null;
        } catch (error) {
            attributes = null;
        }

        if (
            attributes &&
            attributes.hasOwnProperty("replyTo") &&
            attributes.replyTo.dateCreated
        ) {
            attributes.replyTo.dateCreated = new Date(
                attributes.replyTo.dateCreated,
            );
        }

        const isDuplicate = this.state.messages.some(
            (existingMessage) =>
                existingMessage.body === message.body &&
                existingMessage.author === this.getUserIdentity() &&
                existingMessage.dateCreated &&
                Date.now() - existingMessage.dateCreated.getTime() < 5000,
        );

        if (isDuplicate) {
            console.log(
                "Skipping duplicate message in main messages:",
                message.body,
            );
            return null;
        }

        const newMessage = {
            sid: Date.now(),
            ...message,
            ...this.prepareMessageTypeFlagsWithType(type, message),
            // type: isMedia ? 'media' : 'text',
            // body: isMedia ? '' :  window.replaceLinksWithATags(newMessage.body),
            author: this.getUserIdentity(),
            author_name: name,
            author_avatar: avatar,
            attributes: attributes,
            is_author: true,
            is_author_agent: is_agent,
            sent_time: this.messageTime(new Date()),
            dateCreated: new Date(),
            key: this.getNextIndex(), //Date.now(),
            has_same_author_as_previous_message: false,
            is_previous_message_event: false,
            is_in_same_minutue_as_previous_message: false,
            // index: messageIndex, // no need of -1,here as it's before adding new message
            last_read_by_users: [],
            is_sending: true,
            is_failed: false,
            is_proceesing: true,
            temp_index: this.state.messages.length,
        };

        this.updateMessageAuthorAndTimestamp(
            this.state.messages.length,
            newMessage,
        );
        this.checkPreviousNextEventMessage(
            this.state.messages.length,
            newMessage,
        );
        newMessage.body = this.prepareDisplayableTextForMessage(newMessage);
        this.state.messages.push(newMessage);

        // this.updateMyLastReadMessage()
        this.moveScrollBar();

        return newMessage;
    }

    addNewMessage(
        newMessage,
        parsedBody = null,
        isToSetFocusOnTextArea = true,
        custom_index = undefined,
    ) {
        if (this.isMessageMedia(newMessage))
            return this.updateMessagesMap(
                newMessage,
                isToSetFocusOnTextArea,
                "",
                "media",
            );

        /* Delete/Clear if message is empty  */
        if (!newMessage.body) return; // this.trashTwilioMessage(newMessage);

        if (!parsedBody) {
            return this.updateMessagesMap(
                newMessage,
                isToSetFocusOnTextArea,
                window.replaceLinksWithATags(newMessage.body),
                MESSAGE.TEXT,
                null,
                custom_index,
            );
        }

        // const parsedBody =  newMessage.body //JSON.parse(newMessage.body);

        /* if (parsedBody && typeof parsedBody !== "object") {
                throw "Parsed, but not Meta data";
            } */

        switch (parsedBody.type) {
            // to remove old undeleted status message if any left while fetching messages
            case MESSAGE.STATUS:
            case MESSAGE.META:
                // console.log("trashing message ", newMessage.body);
                this.trashTwilioMessage(newMessage);
                return;
            case MESSAGE.STATE:
            case MESSAGE.INVITE:
            case MESSAGE.UNINVITE:
            case MESSAGE.ASSIGN:
            case MESSAGE.UNASSIGN:
            case MESSAGE.ATTENTION:
            case MESSAGE.ATTENTION_CLOSED:
            case MESSAGE.REQUEST_STATUS:
            case MESSAGE.REQUEST_STATUS_CLOSED:
            case MESSAGE.SUPPORT:
            case MESSAGE.SUPPORT_CLOSED:
                //  const body = prepareBreadCumbForBoardAndItem(parsedBody.board_id, parsedBody.item_id);
                // console.log(parsedBody);
                this.addProfileData(parsedBody);
                return this.updateMessagesMap(
                    newMessage,
                    isToSetFocusOnTextArea,
                    this.getMessageActionText(parsedBody),
                    parsedBody.type,
                    parsedBody,
                    custom_index,
                );
            case MESSAGE.IMAGE:
            case MESSAGE.VIDEO:
                return this.updateMessagesMap(
                    newMessage,
                    isToSetFocusOnTextArea,
                    parsedBody.url,
                    parsedBody.type,
                    parsedBody,
                    custom_index,
                );
            case MESSAGE.PAYMENT:
                // console.log("payment", parsedBody, newMessage.body);
                return this.updateMessagesMap(
                    newMessage,
                    isToSetFocusOnTextArea,
                    "Payment Link shared",
                    parsedBody.type,
                    parsedBody,
                    custom_index,
                );
            case MESSAGE.NAVIGATION:
                return this.updateMessagesMap(
                    newMessage,
                    isToSetFocusOnTextArea,
                    "Navigated",
                    parsedBody.type,
                    parsedBody,
                    custom_index,
                );
            case MESSAGE.NOTES:
            case MESSAGE.CONVERSATION:
                return this.updateMessagesMap(
                    newMessage,
                    isToSetFocusOnTextArea,
                    this.getMessageActionText(parsedBody),
                    parsedBody.type,
                    parsedBody,
                    custom_index,
                );
            case MESSAGE.TIMER:
                parsedBody.message = useTimeTrackerStore().getEventMessage(
                    parsedBody?.sub_type,
                );
                parsedBody.action = useTimeTrackerStore().getEventAction(
                    parsedBody?.sub_type,
                );
                return this.updateMessagesMap(
                    newMessage,
                    isToSetFocusOnTextArea,
                    parsedBody.message,
                    parsedBody.type,
                    parsedBody,
                    custom_index,
                );
            case MESSAGE.ACTION:
                return this.updateMessagesMap(
                    newMessage,
                    isToSetFocusOnTextArea,
                    this.getMessageActionText(parsedBody),
                    parsedBody.type,
                    parsedBody,
                    custom_index,
                );
            default:
                //console.log('unknow type, message ignored', newMessage.body);
                return;
        }
    }

    updateMessagesMap(
        newMessage,
        isToSetFocusOnTextArea = true,
        body,
        type = MESSAGE.TEXT,
        data = null,
        custom_index = undefined,
    ) {
        let messageIndex = this.getMessageIndex(newMessage);
        let isToReplace = true;
        /* if not, it's new message insert at the end */

        if (messageIndex == -1) {
            isToReplace = false;
            messageIndex = custom_index ?? this.state.messages.length;
        } else {
            const tmpBody = this.state.messages[messageIndex].body;
            if (type == MESSAGE.MEDIA) body = tmpBody;
        }

        const {messages} = this.state;

        // const isMedia = this.isMessageMedia(newMessage);

        let attributes;

        try {
            if (typeof newMessage.attributes === "string") {
                attributes = newMessage.attributes
                    ? JSON.parse(newMessage.attributes)
                    : null;
            } else if (typeof newMessage.attributes === "object") {
                attributes = newMessage.attributes;
            }
        } catch (error) {
            attributes = null;
        }

        const {name, avatar, is_agent} =
            this.getMessageAuthorDetail(newMessage);

        if (
            attributes &&
            attributes.hasOwnProperty("replyTo") &&
            attributes.replyTo.dateCreated
        ) {
            attributes.replyTo.dateCreated = new Date(
                attributes.replyTo.dateCreated,
            );
        }

        const message = {
            sid: newMessage.sid,
            body,
            ...this.prepareMessageTypeFlagsWithType(type),
            // type: isMedia ? 'media' : 'text',
            // body: isMedia ? '' :  window.replaceLinksWithATags(newMessage.body),
            media_type: this.getFileType(newMessage?.media?.state?.contentType),
            attributes: attributes,
            author: newMessage.author,
            is_author: this.isAuthorsMessage(newMessage),
            is_author_agent: is_agent,
            author_name: name,
            author_avatar: avatar,
            created_at: new Date(newMessage.dateCreated),
            dateCreated: newMessage.dateCreated,
            sent_time: this.messageTime(newMessage),
            key: this.getNextIndex(), //Date.now(),
            has_same_author_as_previous_message: false,
            is_previous_message_event: false,
            is_in_same_minutue_as_previous_message: false,
            index: newMessage.index, // no need of -1,here as it's before adding new message
            is_deleted: attributes?.status === "deleted",
            is_failed: attributes?.status === "failed",
            last_read_by_users: [],
            data,
            updateBody: (str) => newMessage.updateBody(str),
            updateAttributes: (val) => newMessage.updateAttributes(val),
        };

        //let messages_length = messages.length

        if (newMessage.isToSkipSplice) {
            return message;
        }

        this.updateMessageAuthorAndTimestamp(messageIndex, message);
        this.checkPreviousNextEventMessage(messageIndex, message);
        messages.splice(messageIndex, isToReplace ? 1 : 0, message);

        if (type != MESSAGE.MEDIA /* !isMedia */) {
            // this.state.messages = messages;
            this.moveScrollBar(isToSetFocusOnTextArea);
            return message;
        }

        // fetch file url and update the corresponsidng value in map
        // it has to be index(length-1)
        // const indexToUpdateMessageBody = messages.length - 1;

        if (type === MESSAGE.IMAGE || type === MESSAGE.VIDEO) {
            messages.splice(messageIndex, 1, message);
            this.moveScrollBar(isToSetFocusOnTextArea);
        }
        // newMessage
        //   .media
        //   .getContentTemporaryUrl()
        //   .then((url) => {
        //     message.body = url;
        //     message.key = Date.now();
        //     // messages.splice(indexToUpdateMessageBody, 1, message);
        //     messages.splice(messageIndex, 1, message);
        //     this.moveScrollBar(isToSetFocusOnTextArea);
        //   });

        return message;
    }

    getNextIndex() {
        return ++this.index_key;
    }

    updateMessage(newMessage, isToSetFocusOnTextArea = true) {
        const messageIndex = this.getMessageIndex(newMessage);
        if (messageIndex == -1)
            return console.log("Not message found to update");
        const message = this.state.messages[messageIndex];
        message.sid = newMessage.sid;
        message.index = newMessage.index;
        message.updateBody = (str) => newMessage.updateBody(str);
        message.updateAttributes = (val) => newMessage.updateAttributes(val);

        let attributes;
        try {
            attributes = newMessage.attributes
                ? JSON.parse(newMessage.attributes)
                : null;
        } catch (error) {
            attributes = null;
        }

        if (
            attributes &&
            attributes.hasOwnProperty("replyTo") &&
            attributes.replyTo.dateCreated
        ) {
            attributes.replyTo.dateCreated = new Date(
                attributes.replyTo.dateCreated,
            );
        }

        if (
            attributes &&
            attributes.hasOwnProperty("image_update_message_id")
        ) {
            attributes.image_update_message_id.forEach((id) => {
                const index =
                    this.state.buffered_image_upload_message.findIndex(
                        (message) => message.id === parseInt(id),
                    );

                if (index >= 0)
                    this.state.buffered_image_upload_message.splice(index, 1);
            });

            message.body = newMessage.body;
        }

        message.attributes = attributes;

        if (!this.isMessageMedia(message)) return;

        message.body = message.data.url;
        //message.type = message.data.type;
        message.key = Date.now();
        this.state.messages.splice(messageIndex, 1, message);
        this.moveScrollBar(isToSetFocusOnTextArea);
        // newMessage
        //   .media
        //   .getContentTemporaryUrl()
        //   .then((url) => {
        //     message.body = url;
        //     message.key = Date.now();
        //     // messages.splice(indexToUpdateMessageBody, 1, message);
        //     this.state.messages.splice(messageIndex, 1, message);
        //     this.moveScrollBar(isToSetFocusOnTextArea);
        //   });
    }

    prepareMessageTypeFlagsWithType(type, message = null) {
        return {
            type: message ? message?.data?.type : type,
            is_media: this.isMessageMedia({type: type, data: message?.data}),
            is_text: type == MESSAGE.TEXT,
            is_state: type == MESSAGE.STATE,
            is_payment: type == MESSAGE.PAYMENT,
            is_invite: type == MESSAGE.INVITE,
            is_uninvite: type == MESSAGE.UNINVITE,
            is_attention: type == MESSAGE.ATTENTION,
            is_attention_closed: type == MESSAGE.ATTENTION_CLOSED,
            is_request_status: type == MESSAGE.REQUEST_STATUS,
            is_request_status_closed: type == MESSAGE.REQUEST_STATUS_CLOSED,
            is_support: type == MESSAGE.SUPPORT,
            is_support_closed: type == MESSAGE.SUPPORT_CLOSED,
            is_assign: type == MESSAGE.ASSIGN,
            is_unassign: type == MESSAGE.UNASSIGN,
            is_navigation: type == MESSAGE.NAVIGATION,
            is_timer: type == MESSAGE.TIMER,
            is_conversation: type == MESSAGE.CONVERSATION,
            is_action: type == MESSAGE.ACTION,
            is_notes: type == MESSAGE.NOTES,
        };
    }

    isMessageDuplicate(newMessage) {
        return this.getMessageIndex(newMessage) > -1;
    }

    getMessageIndex(message) {
        if (!message) return -1;
        return this.state.messages.findIndex(
            (msg) => msg.index == message?.index || msg.sid == message?.sid,
        );
    }

    getMessageBySid(message) {
        return this.state.messages.find((msg) => msg.sid == message.sid);
    }

    isFetchedInitialMessage() {
        return this.state.is_initial_messages_fetched;
    }

    updateMessageAuthorAndTimestamp(messageIndex, message) {
        if (messageIndex == 0) {
            return;
        }

        const previous_message = this.getMessages()[messageIndex - 1];
        if (!previous_message) {
            return;
        }
        message.has_same_author_as_previous_message =
            message.author == previous_message.author;
        message.is_in_same_minutue_as_previous_message = !this.diff_minutes(
            message.dateCreated,
            previous_message.dateCreated,
        );
    }

    checkPreviousNextEventMessage(messageIndex, message) {
        if (messageIndex == 0) return;

        const previous_message = this.getMessages()[messageIndex - 1];
        message.is_previous_message_event =
            this.isMessageEvent(previous_message);
    }

    isMessageEvent(message) {
        return (
            message?.is_assign ||
            message?.is_invite ||
            message?.is_unassign ||
            message?.is_uninvite ||
            message?.is_attention ||
            message?.is_attention_closed ||
            message?.is_request_status ||
            message?.is_request_status_closed ||
            message?.is_support ||
            message?.is_support_closed ||
            message?.is_navigation ||
            message?.is_timer ||
            message?.is_conversation ||
            message?.is_action
        );
    }

    isMessageUrgentRequest(message) {
        return (
            message?.is_attention ||
            message?.is_attention_closed ||
            message?.is_request_status ||
            message?.is_request_status_closed ||
            message?.is_support ||
            message?.is_support_closed
        );
    }

    hasAlredyRegisteredForMessageAddedEvent() {
        return this.isRegisterdForMessageAddedEvent;
    }

    registeringHandlersCompleted() {
        this.isRegisterdForMessageAddedEvent = true;
    }

    resetHandlersEvent() {
        this.isRegisterdForMessageAddedEvent = false;
    }

    isCurrentConversation() {
        return getCurrentConversationId() == this.id;
    }

    isCurrentConversationAndChatPanelOpened() {
        return (
            this.isCurrentConversation() && useAppState().is_conversation_open
        );
    }

    forceUiUpdate() {
        this.updateLastReadUsersForMessages();
        this.prepareParticipantsStatus();
        // this.updateUserStatusIndicators();
        // this.fetchTwilioParticipants();
        // this.scrollBarHandler();
    }

    moveScrollBar(isToSetFocusOnTextArea = true) {
        if (this.isCurrentConversation() && this.scrollBarHandler) {
            this.scrollBarHandler(isToSetFocusOnTextArea);
        }
    }

    isMessageMedia(message) {
        return (
            message?.type === MESSAGE.IMAGE ||
            message?.type === MESSAGE.VIDEO ||
            (message?.type == MESSAGE.STATE &&
                (message?.data?.type === MESSAGE.IMAGE ||
                    message?.data?.type === MESSAGE.VIDEO))
        );
    }

    trashTwilioMessage(twilioMessage, timeOut = 1000) {
        if (!this.isAuthorsMessage(twilioMessage)) return; // console.log("can't be trashed im't not author");

        const timeOutHandler = setTimeout(() => {
            clearTimeout(timeOutHandler);

            if (this.isTwilioMessageTemporary(twilioMessage)) {
                // console.log("Deleting twilio message : ", { name:  this.getName(), body: twilioMessage.body});
                twilioMessage.remove();
            }
        }, timeOut);
    }

    isTwilioMessageTemporary(twilioMessage) {
        const parsedBody = this.parseTwilioMessageBody(twilioMessage);

        if (!parsedBody) return false;

        return (
            parsedBody.type == MESSAGE.STATUS || parsedBody.type == MESSAGE.META
        );
    }

    /**
     *
     * @param FormData Or string message
     * @returns
     */
    async sendToConversation(message, attr = null) {
        useConversation().updateConnectionStatusIfNotConnected();

        if (useAppState().is_internet_disconnected) {
            await new Promise((resolve) => setTimeout(resolve, 5000));
            throw "Internet disconnected";
        }

        const data = await this.uploadAndChangeSrcOfImage(message, attr);

        return this.getTwilioConversation()
            ?.sendMessage(data.message, data.attributes)
            .then((res) => {
                return res;
            })
            .catch((e) => {
                console.log(
                    `sendToconversation:: Message sending failed: ${e.code} : ${e.message}`,
                );

                throw e;
            });
    }

    getMessageFromNotProcessedByIndex(messageIndex) {
        const index = this.messagesNotProcessed.findIndex(
            (msg) => msg.index == messageIndex,
        );
        if (index == -1) return;
        return this.messagesNotProcessed.splice(index, 1)[0];
    }

    sendMessage(message, attr = null) {
        let new_attr = null;

        message = message.trim();

        this.setMessageTyped("");

        if (!message) return;

        new_attr = attr ? JSON.stringify(attr) : null;

        if (this.hasConversationNotCreated() || this.areMessagesBuffered())
            return this.sendToBuffer(
                {body: message, attributes: new_attr},
                MESSAGE.TEXT,
            );
        //return this.sendToBuffer({body: message, attributes: attr}, 'text');

        // const object_attr = attr ? {
        //     replyTo: {
        //         sent_time: attr.sent_time,
        //         author_name: attr.author_name,
        //         body: attr.body
        //     }
        // } : null

        const newMessage = this.addNewMessageToBeReplaced(
            {
                body: window.replaceLinksWithATags(message),
                attributes: new_attr,
            },
            "text",
        );

        if (!newMessage) {
            return;
        }

        // if (!this.checkConnectionBeforeSend(
        //     newMessage,
        //     newMessage.temp_index,
        //     message,
        //     new_attr,
        // )) {
        //     return
        // }

        this.processToSendConversation(
            message,
            new_attr ?? attr,
            newMessage,
            (messageIndex) => {
                if (messageIndex > -1) {
                    this.updateBufferedEditedMessage(newMessage, messageIndex);
                    newMessage.index = messageIndex;
                }

                newMessage.is_proceesing = false;

                this.updateLastReadUsersForMessages();

                if (
                    this.is_dm &&
                    !message.is_author_agent &&
                    this.isAgentConversation()
                ) {
                    const participant = this.getParticipants()?.find(
                        (participant) => participant?.is_agent == true,
                    );

                    if (participant) {
                        participant.identity = participant.twilio_identity;
                        this.userStartedTyping(participant);
                    }

                    axios.post(
                        `conversations/${this.id}/messages/kaamfu-agent`,
                        {
                            message: message,
                            is_agent: useAppState().is_agent,
                            index: messageIndex,
                        },
                    );
                }
            },
            () => {
                newMessage.is_proceesing = true;
                this.state.messages[newMessage.temp_index].is_proceesing = true;
                this.state.messages[newMessage.temp_index].temp_index =
                    newMessage.temp_index;
            },
        );

        this.updateConversationLastMessageSentAtWith(message);
    }

    processToSendConversation(
        message,
        new_attr,
        newMessage = null,
        success_call_back,
        catch_call_back,
        retry_count = 0,
    ) {
        const max_retries = 50;

        this.sendToConversation(message, new_attr)
            .then((messageIndex) => success_call_back(messageIndex))
            .catch((ex) => {
                catch_call_back();

                if (retry_count >= max_retries) {
                    console.error(
                        `processToSendConversation: Max retries (${max_retries}) exceeded`,
                        ex,
                    );
                    return;
                }

                const base_delay_ms = 1000;
                const exponential_delay =
                    base_delay_ms * Math.pow(2, retry_count);
                const max_delay_ms = 30000;
                const capped_delay = Math.min(exponential_delay, max_delay_ms);
                const jitter_ms = Math.random() * 1000;
                const delay_ms = capped_delay + jitter_ms;

                setTimeout(() => {
                    this.processToSendConversation(
                        newMessage?.body ?? message,
                        new_attr,
                        newMessage,
                        success_call_back,
                        catch_call_back,
                        retry_count + 1,
                    );
                }, delay_ms);
            });
    }

    async uploadAndChangeSrcOfImage(message, attr) {
        if (this.state.buffered_image_upload_message.length === 0)
            return {message: message, attributes: attr};
        let data = [],
            update_message = message;
        const regex = /(<([^>]+)>)/gi;

        message.replace(regex, async (match, p1) => {
            if (
                p1.startsWith("<img") ||
                p1.startsWith("<video") ||
                p1.startsWith("<file")
            ) {
                let srcRegex = /src="([^">]+)"/i;
                const srcMatch = srcRegex.exec(p1);

                srcRegex = /random_id="([^">]+)"/i;
                const idMatch = srcRegex.exec(p1);

                if (idMatch?.[1]) {
                    data.push({
                        src: srcMatch?.[1],
                        random_id: idMatch?.[1],
                    });
                }
            }

            return p1;
        });

        if (data.length) {
            try {
                const promises = data.map(async (item) => {
                    const index =
                        this.state.buffered_image_upload_message.findIndex(
                            (message) =>
                                message.id === parseInt(item.random_id),
                        );

                    if (index >= 0) {
                        const file =
                            this.state.buffered_image_upload_message[index]
                                .file;
                        return {
                            ...item,
                            data: await uploadFile(file, {
                                type: "conversation",
                                id: this.id,
                                collection: "conversations",
                            }),
                        };
                    }

                    return {
                        ...item,
                        data: null,
                    };
                });

                const results = await Promise.all(promises);
                let random_ids = [];

                results.forEach((result) => {
                    update_message = update_message.replace(
                        result.src,
                        result.data.url,
                    );
                    random_ids.push(result.random_id);
                });

                if (attr) {
                    attr = JSON.parse(attr);
                    attr.image_update_message_id = random_ids;
                } else {
                    attr = {
                        image_update_message_id: random_ids,
                    };
                }

                attr = JSON.stringify(attr);
            } catch (error) {
                console.error("Error uploading files", error);
            }
        }

        return {message: update_message, attributes: attr};
    }

    // checkConnectionBeforeSend(newMessage, index, message, new_attr) {
    //     if (useConversation().has_twilio_disconnected || useAppState().is_internet_disconnected) {
    //         this.state.unsend_messages.push({newMessage: newMessage, index: index, body: message, attributes: new_attr});

    //         return false;
    //     }

    //     return true;
    // }

    sendJSONData(data, type = "state") {
        if (!data) return;
        const body = prepareBreadCumbForBoardAndItem(
            data.board_id,
            data.item_id,
        );
        if (this.hasConversationNotCreated() || this.areMessagesBuffered())
            return this.sendToBuffer(
                {
                    body,
                    data,
                },
                type,
            );

        const pre_insert_message = this.addNewMessageToBeReplaced(
            {body, data},
            type,
        );
        const ret_val = this.sendToConversation(JSON.stringify(data)).then(
            (messageIndex) => {
                pre_insert_message.index = messageIndex;
                const new_message =
                    this.getMessageFromNotProcessedByIndex(messageIndex);
                this.updateMessage(new_message);
                this.updateLastReadUsersForMessages();

                return this.getMessageIndex(new_message);
            },
        );
        this.updateConversationLastMessageSentAtWith("Shared a state");

        return ret_val;
    }

    sendPaymentLink(invoice) {
        const data = {
            type: MESSAGE.PAYMENT,
            invoice_id: invoice.id,
            expires_at: invoice.expires_at,
        };

        if (this.hasConversationNotCreated() || this.areMessagesBuffered())
            return this.sendToBuffer(
                {
                    body,
                    data,
                },
                MESSAGE.PAYMENT,
            );

        const newMessage = this.addNewMessageToBeReplaced(
            {body: "Payment Link Shared", data},
            data.type,
        );
        this.sendToConversation(JSON.stringify(data)).then((messageIndex) => {
            newMessage.index = messageIndex;
            this.updateMessage(
                this.getMessageFromNotProcessedByIndex(messageIndex),
            );
            this.updateLastReadUsersForMessages();
        });
    }

    async sendMultiMediaMessage(fileOrBlob) {
        const previewUrl = URL.createObjectURL(fileOrBlob);
        if (this.hasConversationNotCreated())
            return this.sendToBuffer(
                {
                    body: previewUrl,
                    media: fileOrBlob,
                    media_type: this.getFileType(fileOrBlob.type),
                },
                MESSAGE.MEDIA,
            );

        const newMessage = this.addNewMessageToBeReplaced(
            {
                body: previewUrl,
                media_type: this.getFileType(fileOrBlob.type),
            },
            MESSAGE.MEDIA,
        );
        this.sendFile(fileOrBlob).then((messageIndex) => {
            newMessage.index = messageIndex;
            this.updateMessage(
                this.getMessageFromNotProcessedByIndex(messageIndex),
            );
            this.updateLastReadUsersForMessages();
        });
        this.updateConversationLastMessageSentAtWith("Shared a file");
    }

    getFileType(type) {
        if (/video/i.test(type)) return "video";
        else if (/image/i.test(type)) return "image";

        return null;
    }

    sendFile(fileOrBlob) {
        const formData = new FormData();
        formData.append("file", fileOrBlob);
        return this.sendToConversation(formData);
    }

    isStatusActive() {
        return this.myCurrentStatus == STATUS.ACTIVE;
    }

    isStatusAbsent() {
        return this.myCurrentStatus == STATUS.ABSENT;
    }

    isStatusInActive() {
        return this.myCurrentStatus == STATUS.INACTIVE;
    }

    markAsActive() {
        this.myCurrentStatus = STATUS.ACTIVE;
    }

    markAsInactive() {
        this.myCurrentStatus = STATUS.INACTIVE;
    }

    markAsAbsent() {
        this.myCurrentStatus = STATUS.ABSENT;
    }

    notifyAsActive() {
        if (this.isStatusActive()) return;

        this.syncUnreadIndicator();
        /* if state moving from  InActive -> Active */

        /*
         *  methods toggleUserOfInactivity and sendTemporaryNotificationData are not in use therefore it's commented.
         *  Earlier these functions are called after 25sec(INACTIVE_USER_TIME_THRESHOLD = 25000). but because of this, messages are not marked as read instantly.
         *  Therefore this delay is reduced to 4sec. if in future these methods are required. Please make sure it called
         *  with more delay.
         *
         * */

        /*if (this.isStatusInActive())
            this.toggleUserOfInactivity(false);*/

        // console.log(`notifyAsActive - ${this.getName()} : active`);
        this.markAsActive();

        // this.sendTemporaryNotificationData();
    }

    notifyAsInActive() {
        // if user is alredy absent don't make it as Inactive,
        if (this.isStatusAbsent() || this.isStatusInActive()) return;
        this.toggleUserOfInactivity(true);
        // console.log(`notifyAsInActive - ${this.getName()} : inactive`);
        this.markAsInactive();

        //  this.sendTemporaryNotificationData();
    }

    notifyAsAbsent() {
        if (this.isStatusAbsent()) return;
        // console.log(`notifyAsAbsent - ${this.getName()} : absent` );
        this.releaseManualUnreadHold();
        this.markAsAbsent();
        this.sendTemporaryNotificationData();
    }

    sendTemporaryNotificationData() {
        const data = {
            type: MESSAGE.STATUS,
            storage: "temporary",
            status: this.myCurrentStatus,
        };

        this.sendToConversation(JSON.stringify(data));
    }

    sendMessageToNotifyWithCurrentUrl() {
        return;
        if (
            !this.isCurrentConversation() ||
            this.hasCurrentUrlNotifcationSentTimeNotExpired()
        )
            return;

        const message = JSON.stringify({
            type: "meta",
            current_url: window.location.href,
        });
        this.sendToConversation(message);
    }

    hasCurrentUrlNotifcationSentTimeNotExpired() {
        const now = new Date();

        if (!this.lastCurrentUrlNotificationSentAt) {
            this.lastCurrentUrlNotificationSentAt = now;
            return false;
        }

        const diffInSeconds = Math.floor(
            (now - this.lastCurrentUrlNotificationSentAt) / 1000,
        );
        if (diffInSeconds > 10) return false;

        return true;
    }

    registerForTypeHinting() {
        this.getTwilioConversation().on("typingStarted", (member) =>
            this.userStartedTyping(member),
        );
        this.getTwilioConversation().on("typingEnded", (member) =>
            this.userStoppedTyping(member),
        );
    }

    findParticipantByIdentity(userIdentity) {
        return this.state.participants?.find(
            (paricipant) => paricipant.twilio_identity == userIdentity,
        );
    }

    notifyTyping() {
        if (this.hasConversationNotCreated()) return;

        this.getTwilioConversation().typing();

        /* if( !this.typingThrottler)
                this.typingThrottler = throttle( () => this.twilioConversation.typing(), 500);

            this.typingThrottler(); */
        /*
            //console.log("im typing...")
            this.userTypedLastAt = new Date();
            this.setUpAutoSendingTypingStatusForTimeoutDuration(); */
    }

    // setUpAutoSendingTypingStatusForTimeoutDuration() {
    //     // message deleted, don't stop here
    //     // console.log("type message :", this.getMesssageTyped())
    //     if (!this.getMesssageTyped()?.length) return this.clearTypingTimeOutHandler();

    //     const diff = new Date() - this.userTypedLastAt;
    //     const seconds = Math.floor(diff / 1000);

    //     this.clearTypingTimeOutHandler();

    //     if (seconds > 60) {
    //         this.userTypedLastAt = null;
    //         if (this.isCurrentConversation()) this.toggleUserOfInactivity(true);
    //         return;
    //     }
    //     // for every 3 seconds keep updating
    //     this.typingTimeOutHandler = setTimeout(() => {
    //         this.setUpAutoSendingTypingStatusForTimeoutDuration();
    //     }, 1000);

    //     this.notifyTyping();
    // }

    // clearTypingTimeOutHandler() {
    //     clearTimeout(this.typingTimeOutHandler);
    // }

    userStartedTyping(participant) {
        return this.updateUserStatus(
            {author: participant.identity},
            {status: STATUS.TYPING},
        );
        /* here participant is of twilio's Member record, so it's identity not twilio_identity(it's our internal) */
        this.usersTypingSet.add(
            this.findParticipantByIdentity(participant.identity)?.name,
        );
        this.updateTypingUsersIndicator();
    }

    userStoppedTyping(participant) {
        return this.updateUserStatus(
            {author: participant.identity},
            {status: STATUS.ACTIVE},
        );
        this.usersTypingSet.delete(
            this.findParticipantByIdentity(participant.identity)?.name,
        );
        this.updateTypingUsersIndicator();
    }

    updateUserStatus(twilioMessage, parsedBody) {
        if (!parsedBody?.status)
            return console.log("not possible updating status");

        const participant = this.findParticipantByIdentity(
            twilioMessage.author,
        );
        if (!participant) return;

        participant.status = parsedBody.status;
        // console.log("participant status .. ", participant?.user_name, participant.status);
        this.prepareParticipantsStatus();
    }

    prepareParticipantsStatus() {
        /*
            Present - Typing
            Present - Active
            Present - Inactive
            Absent (Online)
            Absent (Offline)
             */

        this.state.typingUsers.splice(0);
        this.activeUsers.splice(0);
        this.inActiveUsers.splice(0);
        this.absentUsers.splice(0);
        //this.offlineUsers.splice(0);

        this.getParticipants()?.forEach((participant) => {
            if (this.isParticipantAuthor(participant)) return; // console.log(" hmmm author ");
            const username = participant.name;
            // console.log("user and participant identity ",  participant.user_name,  participant.status)
            switch (participant.status) {
                case STATUS.TYPING: // 'Present Typing',
                    this.state.typingUsers.splice(0, 0, participant);
                    break;
                case STATUS.ACTIVE: // 'Present Active',
                    this.activeUsers.splice(0, 0, `${username} (PA)`);
                    break;
                case STATUS.INACTIVE: // 'Present Inactive',
                    this.inActiveUsers.splice(0, 0, `${username} (PI)`);
                    break;
                case STATUS.ABSENT: // 'Absent (Online)',
                case STATUS.OFFLINE: // 'Absent (Offline)'
                default:
                    this.absentUsers.splice(0, 0, `${username} (A)`);
                    break;
            }
        });

        if (this.isCurrentConversation()) this.updateUserStatusIndicators();
    }

    allParticipantsStatusExceptTyping() {
        const seperator = ", ";
        return [
            this.activeUsers.join(seperator),
            this.inActiveUsers.join(seperator),
            this.absentUsers.join(seperator),
        ]
            .filter((status) => status)
            .join(seperator);
    }

    // updateTypingUsersIndicator() {
    //     this.state.typingUser = [...this.usersTypingSet].join(', ');
    //     this.forceUiUpdate();
    // }

    whoIsTyping() {
        return this.state.typingUser;
    }

    getUserName(userIdentityAlias) {
        if (this.areMessagesBuffered()) return loggedInUserName();

        const pariticpiant = this.findParticipantByIdentity(userIdentityAlias);
        return pariticpiant?.name;
    }

    isUserParticipant(user_id) {
        return this.state.participants?.find(
            (paricipant) => paricipant.id == user_id,
        );
    }

    getParticipantByIdentity(paricipant_id) {
        return this.state.participants?.find(
            (paricipant) => paricipant.twilio_identity == paricipant_id,
        );
    }

    getParticipantByProfileId(profile_id) {
        return this.state.participants?.find(
            (paricipant) => paricipant.id == profile_id,
        );
    }

    getMessageAuthorName(message) {
        let participant = this.getParticipants()?.find(
            (user) => user.twilio_identity == message.author,
        );

        if (!participant) {
            participant = this.getProfileByUserId(message.author);
        }

        return participant?.name;
    }

    getMessageAuthorDetail(message) {
        let participant = this.getParticipants()?.find(
            (user) => user.twilio_identity == message.author,
        );

        if (!participant) {
            participant = this.getProfileByUserId(message.author);

            return {
                name: participant?.display_name,
                avatar: participant?.avatar_url,
                is_agent: participant?.is_agent,
            };
        }

        return {
            name: participant?.name,
            avatar: participant?.avatar_url,
            is_agent: participant?.is_agent,
        };
    }

    getMessageAuthor(message) {
        let participant = this.getParticipants()?.find(
            (user) => user.twilio_identity == message.author,
        );

        if (!participant) {
            participant = this.getProfileByUserId(message.author);
        }

        return participant || {};
    }

    getProfileByUserId(author_id) {
        return useUserStore().profiles?.find(
            (user_profile) => user_profile.user_id == author_id,
        );
    }

    isNotFromSameAuthorAndWithinSameMinitueAsPreviousMessage(
        messageIndex,
        message,
    ) {
        if (messageIndex == 0) return true;
        const previousMessage = this.getMessages()[messageIndex - 1];

        if (message.author != previousMessage.author) return true;

        return this.diff_minutes(
            message.dateCreated,
            previousMessage.dateCreated,
        );
    }

    isMessageNotOnSameDayAsPreviosMessage(messageIndex) {
        // console.log( "isMessageNotOnSameDayASPrevious" )
        const currentDate = this.state.messages[messageIndex]?.dateCreated;

        if (!currentDate) return;
        if (messageIndex == 0) {
            // console.log(`1 Diff @ ${messageIndex}`, DateUtilities.formatDate(currentDate))
            return DateUtilities.formatDate(currentDate);
        }

        const previousDate = this.state.messages[messageIndex - 1].dateCreated;
        const daysDiffIn2MessagesSendDate = DateUtilities.daysBetween(
            currentDate,
            previousDate,
        );
        // console.log(`2 Diff @ ${messageIndex}`, daysDiffIn2MessagesSendDate)
        /* if both messages are send on same date */
        if (daysDiffIn2MessagesSendDate == 0) return "";
        // console.log(` 3 Diff @ ${messageIndex}`, DateUtilities.formatDate(currentDate))
        return DateUtilities.formatDate(currentDate);
    }

    diff_minutes(dt2, dt1) {
        return DateUtilities.minutesBetween(dt1, dt2);
    }

    isToDisplayTimeStamp(message, messageIndex) {
        const previousMessage = this.getMessages()[messageIndex - 1];
        if (messageIndex == 0 || !previousMessage) return true;
        return (
            message.sent_time != previousMessage?.sent_time ||
            !message.has_same_author_as_previous_message ||
            message.is_deleted
        ); //|| message.attributes?.urgent_request;
    }

    formatMessageTimeStamp(message) {
        return intlDateTimeFormatter.value.format(message.dateCreated);
    }

    messageTime(message) {
        if (!message) return;
        return intlDateTimeFormatterOnlyTime.value.format(message.dateCreated);
    }

    isAuthorsMessage(message) {
        if (this.areMessagesBuffered()) return true;

        return this.getUserIdentity() == message?.author;
    }

    isParticipantAuthor(participant) {
        return this.getUserIdentity() == participant.twilio_identity;
    }

    getMessages() {
        if (this.cachedMessages.length) return this.cachedMessages;
        //if (this.isSendingBufferedMessagesInProgress) return [];
        if (
            this.isSendingBufferedMessagesInProgress ||
            this.areMessagesBuffered()
        )
            return this.state.bufferedMessages;
        return this.state.messages;
    }

    setComponentCallbackHandlers(
        scrollBarHandler,
        toggleUserOfInactivity,
        updateUserStatusIndicators,
    ) {
        if (scrollBarHandler !== undefined) {
            this.scrollBarHandler = scrollBarHandler;
        }
        if (toggleUserOfInactivity !== undefined) {
            this.toggleUserOfInactivity = toggleUserOfInactivity;
        }
        if (updateUserStatusIndicators !== undefined) {
            this.updateUserStatusIndicators = updateUserStatusIndicators;
        }
        this.moveScrollBar();
    }

    getTotalLoadedMessages() {
        return this.state.messages.length;
    }

    areMessagesBuffered() {
        return this.state.bufferedMessages.length;
    }

    areAllMessagesNotLoaded() {
        return this.state.total_messages != this.getTotalLoadedMessages();
    }

    sendToBuffer(messageDetail, type = MESSAGE.TEXT) {
        // this.createConversation();

        const isDuplicate = this.state.bufferedMessages.some(
            (existingMessage) =>
                existingMessage.body === messageDetail.body &&
                existingMessage.author === this.getUserIdentity() &&
                existingMessage.dateCreated &&
                Date.now() - existingMessage.dateCreated.getTime() < 5000,
        );

        if (isDuplicate) {
            console.log(
                "Skipping duplicate message in buffer:",
                messageDetail.body,
            );
            return;
        }

        const newMessage = this.prepareBufferedMessage(messageDetail, type);

        /* switch (type) {
                case 'text':
                    newMessage = { ...newMessage, ...messageDetail }
                    break;
                case 'media':
                    break;
                    case 'data':
                        newMessage  = { }
                        break;
                    } */

        /* if(type == 'media') {
                newMessage.body = { ...newMessage, URL.createObjectURL(message) };
                newMessage.media = message
            } */

        this.state.bufferedMessages.push(newMessage);
        this.moveScrollBar();
    }

    prepareBufferedMessage(messageDetail, type = MESSAGE.TEXT) {
        let newMessage = {
            author: this.getUserIdentity(),
            author_email: useUserStore().user_data.user?.email,
            author_name: useUserStore().profile?.display_name,
            is_author: true,
            dateCreated: new Date(),
            has_same_author_as_previous_message: false,
            is_previous_message_event: false,
            ...messageDetail,
            ...this.prepareMessageTypeFlagsWithType(type),
        };

        this.updateMessageAuthorAndTimestamp(
            this.state.bufferedMessages.length,
            newMessage,
        );
        this.checkPreviousNextEventMessage(
            this.state.bufferedMessages.length,
            newMessage,
        );

        return newMessage;
    }

    async sendBufferedMessages() {
        if (!this.areMessagesBuffered() || this.hasConversationNotCreated())
            return;

        this.isSendingBufferedMessagesInProgress = true;
        let message;

        for (const message of this.state.bufferedMessages) {
            let message_index, message_to_send;
            switch (message.type) {
                case MESSAGE.TEXT:
                    message_to_send = message.body;
                    //message_index = await this.sendToConversation(message.body)
                    //.then(message_index => this.getMessageFromNotProcessedByIndex(message_index))
                    //this.getMessageFromNotProcessedByIndex(message_index)
                    break;
                case MESSAGE.MEDIA:
                    await this.sendFile(message.media);
                    break;
                case MESSAGE.STATE:
                case MESSAGE.INVITE:
                case MESSAGE.UNINVITE:
                case MESSAGE.ASSIGN:
                case MESSAGE.UNASSIGN:
                case MESSAGE.NAVIGATION:
                case MESSAGE.ATTENTION:
                case MESSAGE.ATTENTION_CLOSED:
                case MESSAGE.REQUEST_STATUS:
                case MESSAGE.REQUEST_STATUS_CLOSED:
                case MESSAGE.SUPPORT:
                case MESSAGE.SUPPORT_CLOSED:
                    message_to_send = JSON.stringify(message.data);
                    //message_index = await this.sendToConversation(JSON.stringify(message.data))
                    //.then(message_index => this.getMessageFromNotProcessedByIndex(message_index))
                    //this.getMessageFromNotProcessedByIndex(message_index)
                    break;
                default:
                    console.log("Invalid message in sending buffered messages");
            }

            message_index = await this.sendToConversation(message_to_send);
            this.getMessageFromNotProcessedByIndex(message_index);
        }

        // this.state.bufferedMessages.forEach(async message => {
        // })

        // while (message = this.state.bufferedMessages[0]) {
        //     //console.log('message ..', message, Date.now());
        //     switch (message.type) {
        //         case 'text':
        //             await this.sendToConversation(message.body);
        //             break;
        //         case 'media':
        //             await this.sendFile(message.media);
        //             break;
        //         case 'state':
        //             await this.sendToConversation(JSON.stringify(message.data));
        //             break;
        //         default:
        //             console.log('Invalid message in sending buffered messages');
        //     }
        //     console.log("message sent..", message.body, Date.now());
        //     this.state.bufferedMessages.shift();
        // }

        this.state.bufferedMessages = [];
        this.isSendingBufferedMessagesInProgress = false;
        if (!(message = this.state.messages[0])) return;
        const messageTxt =
            message.type == MESSAGE.MEDIA ? "Shared a Image" : message.body;
        this.updateConversationLastMessageSentAtWith(messageTxt, true);
    }

    updateConversationLastMessageSentAtWith(
        message = "",
        are_buffered_messages_sent = false,
    ) {
        updateConversationLastMessageSentAt(this.getConversationId(), {
            are_buffered_messages_sent,
            message,
        });
    }

    async createConversation() {
        if (this.isRequestToCreateTwilioConversationAlreadyMade) return;

        try {
            this.setIsCreatingConversation(true);
            this.forceUiUpdate();
            this.isRequestToCreateTwilioConversationAlreadyMade = true;
            let newConversation;
            const payload = {
                type: this.type,
                id: this.type_id,
                participants_profile_ids: this.participants,
            };
            //console.log("payload", payload);
            const is_new_conversation = !this.id;

            const {data} = is_new_conversation
                ? await axios.post("/conversations", payload)
                : await axios.post(`/conversations/${this.id}/create`);

            const isGroupRelated = [TYPE.GROUP, TYPE.GROUP_ONE_OFF].includes(
                this.type,
            );

            if (!is_new_conversation && isGroupRelated) {
                return;
                const checked_invites = useTeam().temp_group_invitable_profile;
                useTeam().temp_group_invitable_profile = [];

                useConversation().inviteUsers(checked_invites, {});
            }
            newConversation = data;
            this.forceUiUpdate();

            if (newConversation) {
                this.restoreConversationData(newConversation);
            }

            /* update conv history if its new converation as
            not logged into chat hisotry as it was registered as fake before  */
            if (is_new_conversation)
                useConversation().openConversationById(this.id);
        } catch (e) {
            this.isRequestToCreateTwilioConversationAlreadyMade = false;
            this.forceUiUpdate();
            console.log("Error while creating Buffered Conversation", e);
        } finally {
            this.setIsCreatingConversation(false);
        }
    }

    restoreConversationData(conversation) {
        this.setHideLoadingIndicatorWith(true);
        this.setConversationVariables(conversation);
        this.initialize();
        this.isRequestToCreateTwilioConversationAlreadyMade = false;
    }

    async loadConversation() {
        try {
            this.forceUiUpdate();
            if (this.is_archived) return this.loadArchivedConversation();
            const payload = {type: this.type, id: this.type_id};
            const {data} = await axios.post("/conversations/get", payload);
            this.forceUiUpdate();

            if (!data) {
                return console.log("conversaion not created it's empty");
            }

            this.setHideLoadingIndicatorWith(true);
            this.setConversationVariables(data);
            this.initialize();
            const conversation_store = useConversation();
            conversation_store.setActiveConversationAtIndex(0);
        } catch (e) {
            this.forceUiUpdate();
            console.log("error while loading conversation", e);
        }
    }

    async reloadExistingConversation() {
        try {
            const {data} = await axios.get(`/conversations/${this.id}`);
            if (!data) {
                return;
            }

            let loading = useConversation().active?.id === this.id
            if (loading) {
                useConversation().startLoader();
                this.setStopLoaderOnLoad();
                this.state.messages = [];
            }
            this.forceUiUpdate();
            this.setTwilioConversation(null);
            this.resetHandlersEvent();
            this.removeInitialMessagesFetched();
            this.removeAsArchivedConversation();
            this.removeIsPaginated();
            this.setConversationVariables(data);
            this.initialize();
        } catch (e) {
            this.forceUiUpdate();
            console.log("error while loading conversation", e);
        }
    }

    async loadArchivedConversation() {
        this.setAsArchivedConversation();
        this.state.isLoadingArchivedConversation = true;
        try {
            const convData = {
                id: this.id,
                name: this.name,
                type: this.type,
                type_id: this.type_id,
            };
            await axios.post("/conversations/verify", convData);

            setTimeout(() => {
                this.moveScrollBar();
                this.state.isLoadingArchivedConversation = false;
            }, 100);

        } catch (error) {
            if (error.response) {
                if (error?.response?.status === HttpStatusCodes.FORBIDDEN) {
                    Utilities().showErrorSnackbar(
                        error?.response?.data?.message,
                    );
                    return;
                }

                const errors = error.response.data?.errors;
                if (errors?.archived && errors?.messages?.length) {
                    this.restoreMessages(errors?.messages);
                    setTimeout(() => {
                        this.moveScrollBar();
                        this.state.isLoadingArchivedConversation = false;
                    }, 100);
                }
            }
        }
    }

    isItemConversationBeingCreated() {
        return this.isRequestToCreateTwilioConversationAlreadyMade;
    }

    resetWithConversation(conversationDetail) {
        this.setConversationVariables(conversationDetail);
        this.initialize();
    }

    updateLastMessageSentAt(last_message_send_at) {
        this.state.last_message_send_at = last_message_send_at;
    }

    /*  */
    isParticipantNew(newPartcipant) {
        const member = this.getParticipants()?.find(
            (participant) =>
                newPartcipant.identity == participant.twilio_identity,
        );
        return !member;
    }

    sendGroupInvitationMessages() {
        let authUser = this.authUser;
        let names = "";
        let ctr = 1;
        this.participants?.forEach((v) => {
            if (authUser.id != v.id) {
                if (this.participants.find((ov) => v.id === ov.id)) {
                    names += "&#x2022; " + v.name + " <br />";
                }
            }
            ctr++;
        });
        const message =
            authUser.first_name +
            " Created Group : <br /> " +
            authUser.first_name +
            " has added: <br />" +
            names;
        this.sendMessage(message);
    }

    /**
     * Called when the user returns from inactive. Must not mark the newest
     * message as read: opening a conversation flips inactive→active while the
     * list may still be at the bottom, which used to wipe the unread line.
     * Viewport observers mark what is actually on screen.
     */
    beforeUpdateParticipantLastReadMessageIndex() {
        this.logUnread("become-active", {
            separator_after_index: this.unreadSeparatorIndex(),
            suppressed: this.isVisibleReadSuppressed(),
            near_bottom: this.isScrolledNearBottom(),
        });
        this.syncUnreadIndicator();

        // Activity alone must not mark the newest message, but once suppress
        // has ended, re-ask observers for what is still in the viewport.
        if (!this.isVisibleReadSuppressed()) {
            this.requestVisibleReadRecheck();
        }
    }

    isDeletedMessage(message) {
        return message?.attributes?.status === "deleted";
    }

    updateMessageStateAsFailedByIndex(message_index) {
        //console.log(this.state.messages[message_index])
        this.failedMessage(this.state.messages[message_index]);
    }

    async failedMessage(message) {
        await message.updateAttributes(JSON.stringify({status: "failed"}));
    }

    async removeMessage(message) {
        const has_image = checkImageExists(message.body);
        if (has_image) {
            const image_urls = grabImageUrls(message.body);
            image_urls.forEach((image_url) => {
                const index = getIndexFromImageSrc(image_url);
                this.removeMedia(index);
            });
        }
        await message.updateAttributes(JSON.stringify({status: "deleted"}));
        await message.updateBody("Message deleted");
    }

    //     async sendAssignedMessage(new_assigned_id, currently_assigned_id) {
    //         let ret_val = [];
    //         const item_category = this.getItemCategory();
    //         /*if (!new_assigned_id)
    //             return
    // */
    //         if (
    //             !item_category?.automatic_end_assignment &&
    //             new_assigned_id != currently_assigned_id
    //         ) {
    //             if (currently_assigned_id && new_assigned_id) {
    //                 await Promise.all([
    //                     this.sendInvitationUpdateMessages(
    //                         [currently_assigned_id],
    //                         "assign",
    //                         "Unassigned",
    //                     ),
    //                     this.sendInvitationUpdateMessages(
    //                         [new_assigned_id],
    //                         "assign",
    //                         "Assigned",
    //                     ),
    //                 ]).then((values) => {
    //                     ret_val.push(values[0]);
    //                     ret_val.push(values[1]);
    //                 });
    //             } else {
    //                 // End assignment is handled at backend.
    //                 //if (currently_assigned_id && !new_assigned_id)
    //                 //    ret_val.push(await this.sendInvitationUpdateMessages([currently_assigned_id], 'assign', 'Assignment Ended'))

    //                 if (new_assigned_id)
    //                     ret_val.push(
    //                         await this.sendInvitationUpdateMessages(
    //                             [new_assigned_id],
    //                             "assign",
    //                             "Assigned",
    //                         ),
    //                     );
    //             }
    //         }

    //         this.setAssignee(new_assigned_id);

    //         return ret_val;
    //     }

    async sendNavigationMessage() {
        this.sendJSONData(
            {
                type: MESSAGE.NAVIGATION,
                title: document.title,
                link: window.location.origin + window.location.pathname,
            },
            MESSAGE.NAVIGATION,
        );
    }

    async sendTimerEventMessage(event_type, message, action) {
        this.sendJSONData(
            {
                type: MESSAGE.TIMER,
                sub_type: event_type,
                message: message,
                action: action,
            },
            MESSAGE.TIMER,
        );
    }

    // async sendInvitationForProfiles(new_profile_ids) {
    //     return await this.sendInvitationUpdateMessages(
    //         new_profile_ids,
    //         "invite",
    //         "Added",
    //     );
    // }

    // async sendRemovedInvitationForProfiles(deleted_profile_ids) {
    //     return await this.sendInvitationUpdateMessages(
    //         deleted_profile_ids,
    //         "invite",
    //         "Removed",
    //     );
    // }

    // async sendGroupCreationInvitaitonForProfiles(new_profile_ids, is_one_off) {
    //     useTeam().temp_group_invitable_profile = new_profile_ids;
    //     await this.sendMessage(`${is_one_off ? "Topic" : "Group"} Created`);
    //     return await this.sendInvitationUpdateMessages(
    //         new_profile_ids,
    //         "invite",
    //         "Added",
    //     );
    // }

    // async sendInvitationUpdateMessages(profile_ids, type, message) {
    //     if (!profile_ids?.length) return;

    //     let data = {
    //         type: type,
    //         message: message,
    //         user_profiles: [],
    //     };
    //     const unique_profile_ids = [...new Set(profile_ids)];
    //     unique_profile_ids.forEach((user) => {
    //         let user_details = this.getParticipants().find(
    //             (v) => v.id === user,
    //         );

    //         if (user_details)
    //             data?.user_profiles?.push({
    //                 id: user_details.id,
    //                 name: user_details.full_name,
    //                 avatar_url: user_details.avatar_url,
    //             });
    //         else {
    //             user_details = useUserStore().profiles.find(
    //                 (v) => v.id === user,
    //             );
    //             if (user_details && user !== window.profile.id)
    //                 data?.user_profiles?.push({
    //                     id: user_details.id,
    //                     name: user_details.full_name,
    //                     avatar_url: user_details.avatar_url,
    //                 });
    //         }
    //     });

    //     if (!data.user_profiles?.length)
    //         return console.log("send invitation message " + profile_ids);

    //     return this.sendJSONData(data, type);
    // }

    async sendUrgentMessages(profiles, type, message) {
        if (!profiles?.length) return;

        let data = {
            type: type,
            message: message,
            user_profiles: profiles.map((profile) => {
                return {
                    id: profile["id"],
                    first_name: profile["first_name"],
                    last_name: profile["last_name"],
                    avatar_url: profile["avatar_url"],
                    full_name: profile["full_name"],
                    display_name: profile["display_name"],
                    twilio_identity: profile["twilio_identity"],
                    user_profile_id: profile["user_profile_id"],
                    organization_id: profile["organization_id"],
                };
            }),
        };

        if (!data.user_profiles?.length)
            return console.log("send urgent message " + profile_ids);

        return this.sendJSONData(data, type);
    }

    updateParticipantRemovedStatus(participant_id) {
        const participant = this.getParticipantByIdentity(participant_id);
        if (!participant) return;

        participant.is_removed = true;
    }

    areBufferedMessagesEmpty() {
        return this.state.bufferedMessages.length <= 0;
    }

    setInvitationInProgress(val) {
        return (this.state.is_invitation_in_progress = val);
    }

    getLastMessageIndexFromNewlyLoadedMessages() {
        return this.state.lastMessageIndexFromNewlyLoadedMessages;
    }

    setIsCreatingConversation(val) {
        this.state.isCreatingConversation = val;
    }

    setTemporaryId(val) {
        this.temporary_id = val;
    }

    addProfileData(parsedBody) {
        parsedBody?.user_profiles?.forEach((profile) => {
            let participant = this.getParticipantByProfileId(profile?.id);

            if (!participant) {
                participant = useUserStore().profiles.find(
                    (v) => v.id === profile?.id,
                );
            }

            if (participant) {
                profile.name = participant?.full_name;
            }

            if (profile) profile.avatar_url = participant?.avatar_url;
        });
    }

    setReservedMessage(val) {
        this.state.reserved_messages = val;
    }

    pushReservedMessage(val) {
        this.state.reserved_messages.push(val);
    }

    hasReservedMessages() {
        return this.state.reserved_messages.length;
    }

    removeKaamfuRequest(id) {
        if (!id) {
            return Promise.resolve();
        }

        return axios.delete(`/kaamfu-requests/${id}`);
    }

    updateAttributes(attr) {
        if (attr.length == 0) {
            this.setupUrgentRequestsKaamfu([]);
        }

        return axios
            .post(`/kaamfu-requests`, {
                attributes: {
                    urgent_request: attr,
                    last_user_to_update: useUserStore().getTwilioIdentity,
                    date_updated: Date.now(),
                },
                type: attr[0]?.type || EVENT_SUB_TYPES.REQUEST_ATTENTION,
                model_id: this.id,
            })
            .then((response) => {
                if (!response.data.data.reply) {
                    this.setupUrgentRequestsKaamfu(
                        response?.data?.data?.models,
                    );
                }
            });
    }

    async getAttributes() {
        return await this.twilioConversation.value.getAttributes();
    }

    restoreMessages(messages) {
        messages.forEach((message) => {
            message.dateCreated = new Date(message.dateCreated);
            message.dateUpdated = new Date(message.dateUpdated);
            this.addNewMessage(message, this.parseTwilioMessageBody(message));
        });
        this.moveScrollBar();
    }

    async restoreConversation(state = this.state) {
        if (
            useConversation().has_twilio_disconnected ||
            useAppState().is_internet_disconnected
        ) {
            this.setIsRequireClearMessages();
            const has_state =
                useConversation().buffered_restore_conversation.find(
                    (stt) => stt.id === state.id,
                );
            if (has_state) return;
            useConversation().buffered_restore_conversation.push(state);
            return;
        }

        if (this.isRequestToCreateTwilioConversationAlreadyMade) {
            return;
        }
        try {
            useConversation().loading = true;
            this.isRequestToCreateTwilioConversationAlreadyMade = true;
            this.removeInitialMessagesFetched();
            this.setIsRequireClearMessages();
            this.setStopLoaderOnLoad()
            const pendingMediaIds =
                useConversation().getPendingUploadedMediaIdsForConversation(
                    this,
                );
            const payload = pendingMediaIds.length
                ? {uploaded_media_ids: pendingMediaIds}
                : {};
            const {data} = await axios.post(
                `/conversations/${state.id}/restore`,
                payload,
            );
            if (pendingMediaIds.length) {
                useConversation().clearPendingUploadedMediaIdsForConversation(
                    this,
                    pendingMediaIds,
                );
            }
            this.setInvitationInProgress(false);
            this.forceUiUpdate();
            this.setConversationVariables(data.data);
            this.initialize();
            //this.setHideLoadingIndicatorWith(false);

            this.isRequestToCreateTwilioConversationAlreadyMade = false;
        } catch (error) {
            this.isRequestToCreateTwilioConversationAlreadyMade = false;
            if (error?.response?.status === HttpStatusCodes.FORBIDDEN) {
                Utilities().showErrorSnackbar(error?.response?.data?.message);
            }
            console.log("restoreConversation failed", error);
            this.setAsArchivedConversation();
            useConversation().setLoader();
        } finally {

        }
    }

    async removeMedia(index) {
        try {
            await axios.delete(`/medias/${index}`);
        } catch (error) {
            console.log("Error occured while delete");
        }
    }

    removeAllParticipants() {
        // this.state.participants = [];
    }

    firstUnReadMessage() {
        if (!this.unreadMessagesCount) {
            return null;
        }

        const last_read_index = this.currentUserLastReadMessageIndex();
        if (last_read_index == null) {
            return null;
        }

        return findFirstUnreadMessage(this.state.messages, last_read_index);
    }

    getTaskItemForActivityQueueRecipientLookup() {
        const tree = useWorkspaceTree();
        const itemId = this.itemId;

        if (itemId) {
            const treeItem = tree.getItemById(itemId);
            if (treeItem) {
                return treeItem;
            }
        }

        return this.originalData?.item ?? null;
    }

    messageCountsAsActivityQueue(message) {
        if (
            isSameBoardAndStateItemMove(message) ||
            isRenamedChatEvents(message) ||
            isNotesChatEvents(message)
        ) {
            return false;
        }

        const sub_type = message?.data?.sub_type;
        if (!sub_type) {
            return true;
        }

        if (this.getNonAttentionQueueSubTypes().includes(sub_type)) {
            return false;
        }

        if (isTaskStartOrResumeSubType(sub_type)) {
            const item = this.getTaskItemForActivityQueueRecipientLookup();

            return isProfileRecipientOfTaskStartResumeActivityQueue(
                message?.data,
                useUserStore().getCurrentUserProfileId(),
                item?.version,
            );
        }

        if (isHourlyUplineDigestMessageData(message?.data)) {
            return isHourlyDigestSubjectVisibleOnWorkline(
                message?.data,
                useAppState(),
            );
        }

        return true;
    }

    getNonAttentionQueueSubTypes() {
        return [
            "Shift_In",
            "Shift_Out",
            "Shift_Pause",
            "Shift_Resume",
            "Task_Stop",
            "Task_Pause",
        ];
    }

    getNonAttentionNonImmediateQueueSubTypes() {
        return [
            "Shift_In",
            "Shift_Out",
            "Shift_Pause",
            "Shift_Resume",
            "Task_Stop",
            "Task_Pause",
            "Task_Start",
            "Task_Resume",
        ];
    }

    getNonBeepMessageType() {
        return ["timer"];
    }

    getUnreadMessages(_unread_messages_count) {
        try {
            return messagesAfterLastRead(
                this.getMessages(),
                this.currentUserLastReadMessageIndex(),
            );
        } catch (e) {
            return [];
        }
    }

    isUnReadMessageContainsAQMessage(unread_messages_count) {
        const messages = this.getUnreadMessages(unread_messages_count);
        for (const message of messages) {
            if (this.messageCountsAsActivityQueue(message)) {
                return true;
            }
        }

        return false;
    }

    isUnReadMessageFromImmediateSubordinates(
        unread_messages_count,
        immediate_subordinates,
        new_messages = [],
    ) {
        let messages;
        if (new_messages.length !== 0) {
            messages = new_messages;
        } else {
            messages = this.getUnreadMessages(unread_messages_count);
        }

        for (const message of messages) {
            if (
                isTaskStartOrResumeSubType(message?.data?.sub_type) &&
                this.messageCountsAsActivityQueue(message)
            ) {
                return true;
            }

            if (!message?.data?.sub_type) {
                return true;
            }

            const sender_user_profile_id =
                this.getMessageAuthor(message)?.id ?? null;
            if (!sender_user_profile_id) {
                continue;
            }

            if (immediate_subordinates.includes(sender_user_profile_id)) {
                return true;
            }

            if (
                !this.getNonAttentionNonImmediateQueueSubTypes().includes(
                    message?.data?.sub_type,
                )
            ) {
                return true;
            }
        }

        return false;
    }

    isAgentConversation() {
        return (
            this.participants.findIndex(
                (participant) => participant?.is_agent == true,
            ) > -1 && this.participants?.length === 2
        );
    }

    addToBufferedEditedMessage(message) {
        const has_message = this.state.buffered_edited_message?.findIndex(
            (msg) =>
                msg.sid === message.sid &&
                msg.temp_index === message.temp_index,
        );

        if (has_message !== -1 && has_message !== undefined) {
            this.state.buffered_edited_message.splice(has_message, 1, message);
        } else {
            this.state.buffered_edited_message.push(message);
        }
    }

    updateBufferedEditedMessage(message, messageIndex) {
        const index = this.state.buffered_edited_message?.findIndex(
            (msg) =>
                msg.sid === message.sid &&
                msg.temp_index === message.temp_index,
        );

        if (index === -1) return;

        this.state.buffered_edited_message[index].index = messageIndex;
    }

    markAsReadIfCorrectWindowOpenForMessageRead() {
        const is_message_window_open =
            this.getTotalLoadedMessages() > 0 &&
            useAppState().is_conversation_open &&
            useChat().is_message_tab;

        this.logUnread("visit", {
            handled: is_message_window_open,
            loaded_messages: this.getTotalLoadedMessages(),
            is_conversation_open: useAppState().is_conversation_open,
            is_message_tab: useChat().is_message_tab,
        });

        if (!is_message_window_open) {
            return;
        }

        this.seedUnreadIndicator();
        this.requestScrollToFirstUnreadMessage();
        // Switch-back / AQ open: if unread is already on screen, do not wait
        // for a user scroll — settle then mark read and drop AQ.
        this.scheduleVisibleUnreadAcknowledgement("visit");
    }
}

export default Conversation;
